export const frLangDashboard = {
  common: {
    you: 'Vous',
    post: 'Publication',
    article: 'Article',
    create: 'Créer',
    message: 'Message',
    popular: 'Populaire',
    emptyIntegrations: "Vous devez d'abord ajouter des intégrations",
    categories: 'Catégories',
    edit: 'Modifier',
    share: 'Partager',
    plan: 'Forfait',
    sort: 'Trier',
    addArticle: 'Ajouter un article',
    articles: 'Articles',
    users: 'utilisateurs',
    scans: 'scans',
    clicks: 'clics',
    copy: 'Copier',
    customize: 'Personnaliser',
    link: 'lien',
    save: 'Enregistrer',
    uploadFile: 'Téléverser un fichier',
    customImage: 'Image personnalisée',
    customImageTooltip: 'Téléverser une image personnalisée',
    size: 'Taille',
    sizeTooltip: 'Faites glisser le curseur pour définir la taille',
    auto: 'Auto',
    rectangle: 'Rectangle',
    custom: 'Personnalisé',
    clean: 'Nettoyer',
    cleaning: 'Nettoyage',
    download: 'Télécharger',
    downloading: 'Téléchargement',
    preview: 'APERÇU',
    cover: 'Couverture',
    coverTooltip: 'Téléverser une photo de couverture',
    title: 'Titre',
    new: 'Nouveau',
    pro: 'Pro',
    free: 'Gratuit',
    limit: 'Limite',
    websites: 'sites web',
    site: 'Site',
    apiKey: 'Clé API',
    name: 'Nom',
    passwordChange: 'Changement de mot de passe',
    draft: 'Brouillon',
    page: 'Page',
    areYouSure: 'Êtes-vous sûr(e) ?',
    drop: 'Déposer',
    video: 'vidéo',
    image: 'image',
    chooseFile: 'Choisir un fichier',
    nothingFound: 'Aucun résultat trouvé',
    enterCorrectLink: 'Entrez un lien correct',
    off: 'Désactivé',
    disconnect: 'DÉCONNECTER',
    connect: 'CONNECTER',
    copied: 'Copié',
    saved: 'Enregistré',
    lostConnection: 'Connexion perdue',
    addedCategory: 'Catégorie ajoutée',
    none: 'Aucun',
    left: 'Gauche',
    right: 'Droite',
    solid: 'Plein',
    double: 'Double',
    welcome: 'Bienvenue',
    category: 'Catégorie',
    product: 'Produit',
    website: 'Site web',
    items: 'Éléments',
    square: 'Carré',
    round: 'Rond',
    border: 'Bordure',
    shadow: 'Ombre',
    soft: 'Doux',
    hard: 'Fort',
    block: 'Bloc',
    primary: 'Principal',
    additional: 'Supplémentaire',
    normal: 'Normal',
    bold: 'Gras',
    uploadVideo: 'Téléverser une vidéo',
    compact: 'Compact',
    card: 'Carte',
    top: 'Haut',
    center: 'Centre',
    bottom: 'Bas',
    button: 'Bouton',
    addNewItem: 'Ajouter un nouvel élément',
    price: 'Prix',
    priceCaption: 'Ajoutez le prix de votre produit',
    oldPrice: 'Ancien prix',
    oldPriceCaption: "L'ancien prix sera barré",
    areYouSureDeleteItem: 'Êtes-vous sûr(e) de vouloir supprimer cet élément ?',
    add: 'Ajouter',
    active: 'Actif',
    isActive: 'est actif',
    isDisabled: 'est désactivé',
    uploadImage: 'Téléverser une image',
    design: 'Design',
    addAccount: 'Ajouter un compte',
    hey: 'Bonjour',
    activeBackground: 'Arrière-plan actif',
    activeText: 'Texte actif',
    connectDomain: 'Connecter un domaine',
    shortLink: 'Lien court',
    appearanceSaved: 'Apparence enregistrée !',
    blockAdded: 'Bloc ajouté !',
    comingSoon: 'Bientôt disponible',
    easyMoney: 'Gagner facilement',
    content: 'Contenu',
    audience: 'Audience',
    view: 'Voir',
    delete: 'Supprimer',
    file: 'Fichier',
    type: 'Type',
    from: 'De',
    to: 'À',
    fullName: 'Nom complet',
    lastTimeUsed: 'Dernière utilisation',
    noMediaFiles: 'Aucun fichier média pour le moment...',
    withdraw: 'Retirer',
    congrats: 'Félicitations !',
    makeMoneyOnline: "Gagnez de l'argent en ligne !",
  },
  sort: {
    title: 'Trier',
    search: 'Rechercher',
    default: 'Tri par défaut',
    dateNew: 'Date : du plus récent au plus ancien',
    dateOld: 'Date : du plus ancien au plus récent',
    priceLow: 'Prix : du moins cher au plus cher',
    priceHigh: 'Prix : du plus cher au moins cher',
    nameA: 'Nom : A à Z',
    nameZ: 'Nom : Z à A',
    popular: 'Plus populaires',
  },
  emailMenu: {
    broadcasts: 'Diffusions',
    automations: 'Automatisations',
    templates: 'Modèles',
    settings: 'Paramètres',
    noEmails: 'Aucun e-mail pour le moment',
    newBroadcast: 'Nouvelles diffusions',
  },
  aiContent: {
    title: 'Créez votre premier contenu IA !',
    text: 'Planifiez et publiez du contenu sur tous les réseaux sociaux en une seule fois !',
    create: 'Créer un contenu IA',
  },
  pageDesign: {
    page: 'Design de la page',
    image: 'Image',
  },
  toolsMenu: {
    title: 'Outils',
    account: 'Compte',
    instantPages: 'Pages instantanées',
    instantPagesText: 'Pages autonomes à chargement rapide',
    agents: 'Agents',
    agentsText: 'Assistants IA qui gèrent votre profil',
    socialPlanner: 'Planificateur social',
    socialPlannerText: 'Planification de contenu et inspiration',
    emailMarketing: 'Marketing par e-mail',
    emailMarketingText: 'Développez votre liste de contacts',
    smartReply: 'Réponse automatique',
    smartReplyText: 'Envoyez des commentaires et messages automatiques',
    linkShortener: 'Raccourcisseur de liens',
    linkShortenerText: 'Raccourcissez les URL longues',
    posts: 'Publications',
    postsText: 'Créez et gérez vos publications',
    blog: 'Blog',
    blogText: 'Créez et gérez vos articles de blog',
  },
  insideMenu: {
    planner: 'Planificateur',
    aiContent: 'Contenu IA',
    aiPosts: 'Publications IA',
    postIdeas: 'Idées de publication',
    contentPlanner: 'Planificateur de contenu',
    aiImages: 'Images IA',
    brandProjects: 'Projets de marque',
    aiVideo: 'Vidéo IA',
    integrations: 'Intégrations',
    products: 'Produits',
    orders: 'Commandes',
    payments: 'Paiements',
    links: 'Liens',
    qrCodes: 'Codes QR',
  },
  orders: {
    title: 'Commandes',
    empty: "Vous n'avez pas encore de commandes",
    all: 'Toutes les commandes',
    shop: 'Boutique',
    digital: 'Produits numériques',
    appointments: 'Rendez-vous',
    services: 'Services',
    donations: 'Dons',
  },
  discounts: {
    title: 'Réductions',
    newDiscount: '+ Nouvelle réduction',
    code: 'Code',
    titleCol: 'Titre',
    type: 'Type',
    value: 'Valeur',
    status: 'Statut',
    used: 'Utilisé',
    actions: 'Actions',
    statusAll: 'Tous les statuts',
    statusActive: 'Active',
    statusExpired: 'Expirée',
    statusScheduled: 'Planifiée',
    statusInactive: 'Inactive',
    searchPlaceholder: 'Rechercher par code ou titre...',
    clearFilters: 'Effacer les filtres',
    emptyTitle: 'Pas encore de réductions',
    emptySubtitle: 'Créez votre premier code promo pour offrir des réductions sur vos produits',
    createDiscount: 'Créer une réduction',
    createTitle: 'Créer une réduction',
    editTitle: 'Modifier la réduction',
    fieldTitle: 'Titre',
    fieldTitlePlaceholder: 'ex. Vente de printemps',
    fieldCode: 'Code',
    fieldCodePlaceholder: 'ex. SAVE20',
    generate: 'Générer',
    sectionDiscount: 'Réduction',
    fieldType: 'Type',
    typePercentage: 'Pourcentage',
    typeFixed: 'Montant fixe',
    typeFreeShipping: 'Livraison gratuite',
    fieldValue: 'Valeur',
    sectionConditions: 'Conditions (optionnel)',
    appliesTo: "S'applique à",
    appliesToAll: 'Tous les produits',
    appliesToShop: 'Boutique',
    appliesToDigital: 'Numérique',
    appliesToCourses: 'Cours',
    appliesToServices: 'Services',
    appliesToEvents: 'Événements',
    minOrderAmount: 'Montant minimum de commande ($)',
    maxDiscountAmount: 'Montant maximum de réduction ($) — 0 = sans limite',
    minItemCount: "Min. d'articles dans la commande — 0 = aucune exigence",
    specificProducts: 'Produits spécifiques — vide = tous',
    specificProductsPlaceholder: 'Rechercher des produits...',
    noProductsFound: 'Aucun produit trouvé',
    sectionLimits: 'Limites',
    usageLimit: "Limite d'utilisation totale — 0 = sans limite",
    usageLimitPerUser: 'Limite par client — 0 = sans limite',
    sectionSchedule: 'Planification',
    startDate: 'Date de début — vide = commence maintenant',
    endDate: 'Date de fin — vide = sans expiration',
    active: 'Active',
    cancel: 'Annuler',
    save: 'Enregistrer la réduction',
    createdSuccess: 'Réduction créée',
    updatedSuccess: 'Réduction mise à jour',
    deletedSuccess: 'Réduction supprimée',
    loadError: 'Échec du chargement des réductions',
    saveError: "Échec de l'enregistrement de la réduction",
    deleteError: 'Échec de la suppression de la réduction',
  },
  donation: {
    chooseSmiles: 'Choisir des émoticônes',
    item: 'Élément',
    itemTitle: "Titre de l'élément de don",
    price: 'Prix',
    thanksMessagePlaceholder: 'Merci beaucoup',
    thanksMessage: 'Message de remerciement',
    thanksMessageCaption: "Le message de remerciement s'affichera pour vos fans après le don",
    addDonation: 'Ajouter un don',
    addAmount: '+ Ajouter un montant',
    buttonTitle: 'Titre du bouton',
    buttonTitleCaption: 'Titre du bouton de don',
    acceptDonations: 'Accepter les dons',
    donationsType: 'Dons',
    tips: 'Pourboires',
    type: 'Type',
    addAnotherAmount: '+ Ajouter un autre montant',
  },
  blog: {
    empty: "Vous n'avez pas encore de blog",
  },
  apps: {
    empty: "Vous n'avez pas encore d'applications",
  },
  payments: {
    title: 'Paiements',
    text: "Vous n'avez pas encore de transactions",
    single: 'Paiements uniques',
    subscriptions: 'Abonnements',
    wallet: 'Portefeuille',
    connectPromo: 'Connectez votre compte Stripe ou PayPal à votre page UniLink et recevez tous les paiements dans votre portefeuille.',
    connectSystem: 'Connecter un système de paiement',
    manageCards: 'Gérer vos cartes',
    addNewCard: 'Ajouter une nouvelle carte',
    editCard: 'Modifier les informations de la carte',
    addCard: 'Ajouter les informations de la carte',
    cardHolder: 'Nom du titulaire de la carte',
    cardHolderNecessary: 'Ce champ est obligatoire',
    withdrawalSuccess: 'Votre retrait a été soumis avec succès !',
    withdrawalError: "Une erreur s'est produite, veuillez réessayer plus tard.",
    change: 'Modifier',
  },
  store: {
    emptyTitle: 'Vous n’avez pas encore de produits',
    emptyText: 'Commencez par ajouter votre premier produit',
    emptyButton: 'Ajouter un produit',
    createFirstProduct: 'Créez votre premier produit',
    startAdding: 'Commencez par ajouter vos produits préférés, biens numériques ou services. Un espace où vous pouvez vendre et promouvoir tout ce que vous proposez.',
    activate: 'Activer la boutique',
    empty: "Vous n'avez pas encore de produits",
    products: 'Produits',
    addProducts: 'Ajouter des produits',
    whatDoYouWant: 'Que souhaitez-vous vendre ?',
    externalProduct: 'URL de produit externe',
    createOwnProduct: 'Créer votre propre produit',
    shop: 'Boutique',
    shopText: 'Vendez des produits physiques et numériques',
    digital: 'Produits numériques',
    digitalText: 'Vendez un téléchargement numérique',
    course: 'Cours ou tutoriel',
    courseText: 'Ajoutez un cours ou tutoriel au site web',
    service: 'Services',
    serviceText: 'Ajoutez des services pour vos clients',
    appointment: 'Rendez-vous',
    appointmentText: 'Permettez aux visiteurs de réserver un créneau dans votre calendrier',
    event: 'Événements ou billets',
    eventText: 'Créez un événement et invitez votre audience',
    tips: 'Pourboires',
    tipsText: 'Laissez un pourboire à vos créateurs préférés',
    donation: 'Dons',
    donationText: 'Faites un don',
    membership: 'Adhésion',
    membershipText: 'Ajoutez une adhésion au site web',
    links: 'Lien externe',
    linksText: "Ajoutez un lien externe vers n'importe quel site web",
    coupon: 'Coupon',
    couponText: 'Ajoutez un coupon pour votre site web',
    singleProduct: 'Produit unique',
    singleProductText: 'Vendez un produit unique avec un paiement simple',
    booking: 'Réservation',
    bookingText: 'Permettez aux visiteurs de réserver vos espaces ou propriétés',
    rental: 'Location',
    rentalText: 'Listez des articles à louer avec disponibilité et tarifs',
    add: 'Ajouter',
    manageStore: 'Gérer la boutique',
    displayLast: 'Afficher le dernier produit',
  },
  products: {
    info: 'Info',
    uploadCover: 'Téléversez une photo de couverture, puis fournissez un titre et une description',
    thumbnail: 'Miniature',
    thumbnailError: 'Veuillez ajouter une miniature',
    title: 'Titre',
    titleTooltip: 'Entrez le nom de votre produit',
    shortDescription: 'Description courte',
    shortDescriptionTooltip: 'Entrez une courte description de votre produit',
    description: 'Description',
    descriptionTooltip: 'Entrez la description de votre produit',
    descriptionTooltipExtra: 'Description optionnelle des caractéristiques du produit, types, couleurs, tailles, etc.',
    price: 'Prix',
    priceTooltip: 'Entrez le prix de votre produit',
    oldPrice: 'Ancien prix',
    oldPriceTooltip: "L'ancien prix sera barré",
    category: 'Catégorie',
    categoryTooltip: 'Choisissez la catégorie de votre produit',
    image: 'Image',
    imageTooltip: 'Téléversez une image pour votre produit',
    groups: 'Groupes',
    rate: 'Note',
    rateTooltip: 'Entrez la note de votre produit',
    buttonTitle: 'Titre du bouton',
    buttonTitleTooltip: 'Entrez le titre du bouton de votre produit',
    limitQuantity: 'Quantité limitée',
    itemsLeft: 'Articles restants',
    itemsLeftTooltip: 'Articles de votre produit',
    attachments: 'Pièces jointes',
    addAttachments: 'Ajoutez des pièces jointes à vos produits',
    addNewAttachment: 'Ajouter un nouvel élément',
    file: 'Fichier',
    uploadFile: 'Téléverser un fichier',
    uploadCoverTitle: 'Téléverser la couverture',
    optionalDescription: 'Description optionnelle des caractéristiques du produit, types, couleurs, tailles, etc.',
    customReviews: 'Avis personnalisés',
    addCustomReviews: 'Ajoutez des avis à vos produits',
    name: 'Nom',
    nameTooltip: 'Entrez le nom de votre client',
    comment: 'Commentaire',
    commentTooltip: 'Entrez le commentaire de votre client',
    rateTooltipCustomer: 'Note du client',
    imageTooltipCustomer: "Téléversez l'image de votre client",
    displayPriceOnPreview: "Afficher le prix dans l'aperçu",
    displayDetailsOnPreview: "Afficher les détails dans l'aperçu",
    postOnSocials: 'Publier sur les réseaux sociaux',
    sendAnEmail: 'Envoyer un e-mail',
    highlights: 'Points forts',
    listProductSetup: 'Listez le produit et configurez votre bloc boutique',
    whereToSell: 'Où souhaitez-vous vendre ce produit ?',
    youHaveProducts: 'Vous avez {count} produits',
    shareThisProduct: 'Partager ce produit',
    shareAProduct: 'Partager un produit',
    monetizeWays: 'Différentes façons de monétiser sur UniLink',
    addProductToProfile: 'Ajouter un {title} à votre profil',
    productPage: 'Page produit',
    setUpPayments: 'Configurer vos paiements',
    connectPaymentMethods: "Connectez vos méthodes de paiement pour commencer à gagner de l'argent sur UniLink",
    addPaymentMethod: 'Ajoutez une méthode de paiement {type} pour recevoir les paiements de vos abonnés',
    withdrawAttempt: 'Ceci est une tentative de recouvrement de créance et toute information sera utilisée à cette fin.',
    withdrawSuccess: 'Votre retrait a été soumis avec succès !',
    yourVisitorsPay: "Vos visiteurs paieront d'abord, puis seront redirigés vers votre {method}",
    emailAddress: 'adresse e-mail',
    calendlyLink: 'lien Calendly',
  },
  posts: {
    posts: 'Publications',
    title: 'Créez votre première publication',
    description:
      'Les publications vous permettent de créer des automatisations de chat dans un format simple et visuel. Essayez les automatisations que nous recommandons en fonction de vos objectifs',
    activate: 'Activer les publications',
    managePosts: 'Gérer les publications',
    postsTab: 'Onglet publications',
    displayLast: 'Afficher les dernières publications',
    tabNavigation: 'Paramètres de navigation par onglets',
    createFirstPost: 'Créez votre première publication sociale !',
    autoPostsText: 'Planifiez et publiez du contenu sur tous les réseaux sociaux en une seule fois !',
    createPost: 'Créer une publication',
  },
  messages: {
    title: 'Messages',
    empty: 'Aucun message',
    addText: 'Ajoutez un bouton de message au bloc En-tête, permettant aux utilisateurs de vous envoyer facilement un message.',
    addButton: 'Ajouter un bouton Message',
  },
  smartReply: {
    title: 'Réponse automatique',
    clicks: 'clics',
    createTitle: 'Créez votre première réponse automatique !',
    text: 'Utilisez les messages directs automatiques Instagram pour partager automatiquement des liens avec votre audience !',
    createButton: 'Créer une réponse automatique',
  },
  businessCards: {
    title: 'Cartes de visite',
    emptyTitle: 'Créez votre carte de visite numérique',
    emptySubtitle: 'Ajoutez vos coordonnées pour que chacun puisse les enregistrer sur son téléphone en un seul geste, puis partagez-les via un code QR ou un fichier .vcf.',
    createButton: 'Créer une carte de visite',
    sectionButton: 'Bouton « Enregistrer le contact »',
    sectionButtonSubtitle: 'L\'apparence du bouton « Enregistrer le contact » et son emplacement sur votre profil.',
    showButton: 'Afficher sur mon profil',
    showButtonSubtitle: 'Affichez le bouton « Enregistrer le contact » sur votre page publique.',
    placement: 'Emplacement du bouton',
    placementSubtitle: 'Choisissez où le bouton apparaît.',
    showInHeader: 'Afficher dans l’en-tête',
    placementHeader: 'En-tête du profil',
    placementHeaderHint: 'Apparaît juste sous votre nom et votre avatar.',
    placementContact: 'Section Contacts',
    placementContactHint: 'Apparaît dans la fenêtre Contacts.',
    placementBottom: 'Bouton flottant',
    placementBottomHint: 'Reste en bas de la page lors du défilement.',
    none: 'Aucun',
    buttonLabel: 'Libellé du bouton',
    buttonLabelSubtitle: 'Texte affiché sur le bouton.',
    saveContact: 'Enregistrer le contact',
    sectionDetails: 'Coordonnées',
    sectionDetailsSubtitle: 'Ces coordonnées sont enregistrées dans la fiche de contact.',
    delete: 'Supprimer la carte de visite',
    previewHint: 'Voici comment votre carte apparaît aux visiteurs.',
    share: 'Partage et QR',
    shareSubtitle: 'Scannez le code ou partagez le lien pour ouvrir votre profil.',
    download: 'Télécharger le .vcf',
    copyLink: 'Copier le lien',
    copied: 'Lien copié !',
    digitalCard: 'Carte numérique',
    physicalCard: 'Carte physique',
    cardStyle: 'Style de la carte',
    cardStyleSubtitle: 'Définissez votre nom affiché, choisissez une couleur de fond et ajoutez votre carte à un portefeuille.',
    displayName: 'Nom affiché',
    backgroundColour: 'Couleur de fond',
    addAppleWallet: 'Ajouter à Apple Wallet',
    addGoogleWallet: 'Ajouter à Google Wallet',
    nameLabel: 'Nom',
    urlLabel: 'URL',
    walletScanTitle: 'Scannez le code QR pour l\'enregistrer dans votre portefeuille',
    walletScanSubtitle: 'Elle sera enregistrée dans le portefeuille numérique de votre téléphone.',
    walletUseLink: 'Ou utilisez plutôt ce lien',
    walletComingSoonTitle: 'Presque terminé',
    walletComingSoon: 'Les cartes de portefeuille arrivent bientôt.',
    done: 'Terminé',
    physicalTitle: 'Commander une carte physique',
    physicalSubtitle: 'Les cartes de visite NFC arrivent bientôt.',
  },
  shortLinks: {
    title: 'Raccourcisseur de liens',
    addLink: 'Ajouter un lien',
    name: 'Nom',
    slug: 'Slug',
    slugTooltip: 'Vous pouvez modifier le slug en cliquant sur le bouton de modification',
    destinationUrl: 'URL de destination',
    metadata: 'Métadonnées',
    utmTags: 'Tags UTM',
    customizeMetadata: 'Personnaliser les métadonnées du lien',
    metaTitle: 'Titre',
    metaDescription: 'Description',
    favicon: 'Favicon',
    imagePreview: "Aperçu de l'image",
    addUtm: 'Ajouter des tags UTM au lien (optionnel)',
    utmCampaign: 'UTM Campaign',
    utmMedium: 'UTM Medium',
    utmSource: 'UTM Source',
    utmTerm: 'UTM Term',
    utmContent: 'UTM Content',
    utmId: 'UTM Id',
    utmPlacement: 'UTM Placement',
    utmCreative: 'UTM Creative',
    pasteLink: 'Collez votre long lien ici',
    shorten: 'Raccourcir le lien',
    edit: "Modifier les détails de l'élément",
  },
  audience: {
    title: 'Audience',
    total: 'Total',
    totalMembers: "Nombre total de membres de l'audience",
    totalContacts: 'Total des contacts',
    forms: 'Formulaires',
    subscribers: 'Abonnés',
    customers: 'Clients',
    noAudienceMembers: 'Aucun contact',
    emptyAudienceMembers: 'Ajoutez de nouveaux contacts en cliquant sur le bouton',
    addAudienceMember: 'Ajouter un contact',
    noSubscribers: 'Aucun abonné',
    emptySubscribers: 'Ajoutez de nouveaux abonnés en ajoutant des blocs à votre lien en bio',
    addDataCollect: 'Ajouter un bloc Collecte de données',
    noResponses: 'Aucune réponse',
    emptyResponses: 'Ajoutez de nouvelles réponses en ajoutant des blocs à votre lien en bio',
    addFormBlock: 'Ajouter un bloc Formulaire',
    noCustomers: 'Aucun client',
    emptyCustomers: 'Ajoutez de nouveaux clients en ajoutant un produit à votre lien en bio',
    addProduct: 'Ajouter un produit',
    addContactModal: {
      title: 'Ajouter un nouveau contact',
      name: 'Nom',
      nameTooltip: 'Entrez le nom de votre contact',
      email: 'E-mail',
      emailTooltip: "Entrez l'adresse e-mail de votre contact",
      phone: 'Téléphone',
      phoneTooltip: 'Entrez le numéro de téléphone de votre contact',
      telegram: 'Telegram',
      telegramTooltip: "Entrez le nom d'utilisateur ou l'URL Telegram de votre contact",
      whatsapp: 'WhatsApp',
      whatsappTooltip: 'Entrez le numéro WhatsApp de votre contact',
      instagram: 'Instagram',
      instagramTooltip: "Entrez le nom d'utilisateur ou l'URL Instagram de votre contact",
      messenger: 'Messenger',
      messengerTooltip: "Entrez le nom d'utilisateur ou l'URL Messenger de votre contact",
      viber: 'Viber',
      viberTooltip: 'Entrez le numéro Viber de votre contact',
      address: 'Adresse',
      addressTooltip: "Entrez l'adresse de votre contact",
      add: 'Ajouter',
    },
    search: {
      search: 'Rechercher',
      error: 'Caractère invalide saisi dans le champ de recherche',
      notFound: 'Aucun résultat trouvé',
    },
  },
  auth: {
    logIn: 'Se connecter',
    logInWith: 'Se connecter avec',
    signIn: 'Se connecter',
    signInWith: "S'inscrire avec",
    email: 'E-mail',
    password: 'Mot de passe',
    notHaveAccount: "Vous n'avez pas de compte ?",
    createAccount: 'Créer un nouveau compte',
    createYourAccount: 'Créez votre compte',
    signUp: "S'inscrire",
    haveAccount: 'Si vous avez déjà un compte',
    or: 'ou',
    reset: 'Réinitialiser',
    resetPassword: 'Réinitialiser le mot de passe',
    resetTitle: 'Le lien de récupération a été envoyé à votre e-mail',
    goToHome: "Aller à la page d'accueil",
    byClicking: 'En cliquant sur',
    youAreAgree: 'vous acceptez les',
    terms: "Conditions d'utilisation",
    andConfirm: 'et notre',
    usagePolicy: "Politique d'utilisation",
    signInGoogle: 'Se connecter avec Google',
    forgotPassword: 'Mot de passe oublié ?',
  },
  menu: {
    moreApps: "Plus d'applications",
    account: 'Compte',
    more: 'Plus',
    storyWidget: 'Embed Stories',
    integrations: 'Intégrations',
    socialAccounts: 'Comptes sociaux',
    aiContent: 'Contenu IA',
    aiPosts: 'Publications IA',
    postIdeas: 'Idées de publication',
    contentPlanner: 'Planificateur de contenu',
    aiImages: 'Images IA',
    aiVideo: 'Vidéo IA',
    planner: 'Planificateur',
    customers: 'Clients',
    subscribers: 'Abonnés',
    forms: 'Formulaires',
    allAudience: "Toute l'audience",
    payments: 'Paiements',
    orders: 'Commandes',
    products: 'Produits',
    events: 'Événements',
    appointments: 'Rendez-vous',
    discounts: 'Réductions',
    affiliates: 'Affiliés',
    instantPages: 'Pages instantanées',
    openInNewTab: 'Ouvrir dans un nouvel onglet',
    linkInBio: 'Lien en bio',
    linkInBioApps: 'Lien en bio',
    website: 'Site web',
    store: 'Boutique',
    audience: 'Audience',
    emailMarketing: 'Marketing par e-mail',
    postPlaner: 'Planificateur de publications',
    posts: 'Publications',
    agents: 'Agents',
    community: 'Communauté',
    profileHealth: 'Santé du profil',
    socialPlanner: 'Planificateur social',
    shortLinks: 'Raccourcisseur de liens',
    businessCards: 'Cartes de visite',
    views: 'Vues',
    clicks: 'Clics',
    allWebsites: 'Tous les sites web',
    createNewAccount: 'Créer un nouveau compte',
    createNewWebsite: 'Créer un nouveau profil',
    tools: 'Outils',
    borderGenerator: 'Générateur de bordures',
    yourPlan: 'Votre forfait :',
    upgrade: 'Mettre à niveau',
    accountSettings: 'Paramètres du compte',
    manageWebsites: 'Gérer les profils',
    updates: 'Mises à jour',
    autoUpdate: 'Mise à jour automatique',
    logOut: 'Se déconnecter',
    myPages: 'Mes pages',
    design: 'Design',
    heading: 'En-tête',
    analytics: 'Analytique',
    settings: 'Paramètres',
    open: 'Ouvrir',
    language: 'Langue',
    siteLanguage: 'Langue du site public',
    dashboardLanguage: 'Langue du tableau de bord',
    movePage: 'Déplacer la page',
    editBlock: 'Modifier le bloc',
    renameBlock: 'Renommer le bloc',
    rename: 'Renommer',
    deleteBlock: 'Supprimer le bloc',
    archiveBlock: 'Archiver le bloc',
    archive: 'Archiver',
    scheduleBlock: 'Planifier le bloc',
    copyBlock: 'Copier le bloc',
    dublicateBlock: 'Dupliquer le bloc',
    content: 'Contenu',
    preview: 'Aperçu',
    copy: 'Copier',
    moveBlock: 'Déplacer le bloc',
    move: 'Déplacer',
    edit: 'Modifier',
    delete: 'Supprimer',
    schedule: 'Planifier',
    dublicate: 'Dupliquer',
    smartReply: 'Réponse automatique',
    marketing: 'Marketing',
    selectBlocks: 'Sélectionner des blocs',
    selectAll: 'Tout sélectionner',
    cancelSelection: 'Annuler',
    blocksSelected: 'sélectionnés',
    moveToPage: 'Déplacer vers la page',
    newPage: 'Nouvelle page',
    openPage: 'Ouvrir la page',
    pageSettings: 'Paramètres de la page',
    deletePage: 'Supprimer la page',
    appInBio: 'App en bio',
    blog: 'Blog',
    publish: 'Publier',
    creatorHub: 'Hub créateur',
    qrCodes: 'Codes QR',
    apps: 'Apps',
    automations: 'Automatisations',
    messages: 'Boîte de réception',
    form: 'Formulaires',
    embedTools: 'Embed Tools',
  },
  modal: {
    addInstagram: 'Ajouter Instagram',
    addYourInstagram: 'Ajoutez votre compte Instagram',
    cropYourAvatar: 'Recadrer votre avatar',
    removeSite: 'Êtes-vous sûr(e) de vouloir supprimer le site ?',
    areYouSure: 'Êtes-vous sûr(e) de vouloir',
    areYouSureDelete: 'Êtes-vous sûr(e) de vouloir supprimer cette section ?',
    areYouSureArchive: 'Êtes-vous sûr(e) de vouloir archiver ce bloc ?',
    areYouSurePermanentDelete: 'Êtes-vous sûr(e) de vouloir supprimer définitivement ce bloc ? Cette action est irréversible.',
    remove: 'supprimer',
    site: 'site',
    removeAccountText: 'supprimer votre compte',
    moveBlock: 'Déplacer le bloc vers une autre page',
    moveBlockText: "Le bloc sera déplacé en bas d'une autre page. Vous pourrez ensuite réorganiser le bloc sur la nouvelle page",
    profileTitle: 'Changer la photo de profil',
    profileText: 'Choisissez une image ou un GIF depuis votre appareil.',
    profileAvatar: 'Avatar de profil',
    addProfilePicture: 'Ajouter une photo de profil',
    storiesTitle: 'Stories',
    storiesText: 'Partagez vos moments quotidiens.',
    thoughtsTitle: 'Pensées',
    thoughtsText: 'Partagez vos pensées.',
    accountPageDescription: "Ceci est votre page de compte, où vous pouvez personnaliser l'apparence de votre page, ajouter différents blocs de fonctionnalités, et plus encore.",
  },
  modalSubscribe: {
    plan: 'Forfait',
    usdMonth: 'USD/mois',
    sites: 'Sites',
    sitesMuch: 'Sites',
    notification: 'Notifications',
    noNotification: 'Aucune notification pour le moment',
    inCategory: "Il n'y a aucun élément dans la catégorie",
    categoryYet: 'pour le moment.',
    externalPixels: 'Pixels externes',
    parameters: 'paramètres',
    analyticsReports: 'Analytique et rapports',
    noUniLinkLogo: 'Sans logo UniLink',
    inProfile: 'dans le profil',
    verifiedBadge: 'Badge vérifié',
    your: 'Votre',
    customDomain: 'domaine personnalisé',
    emailMarketing: 'Marketing par e-mail',
    liveSupport: 'Support en direct',
    dataSecured: 'Les données sont sécurisées conformément à la norme PCI DSS',
    thankYou: 'Merci pour votre intérêt. Nous vous contacterons bientôt.',
    socialMediaScheduler: 'Planificateur de réseaux sociaux',
    featureRequest: 'Demande de fonctionnalité',
    markAllRead: 'Tout marquer comme lu',
    currentPlan: 'Forfait actuel',
    features: 'Fonctionnalités',
  },
  buttons: {
    upgrade: 'Mettre à niveau',
    buyProPlan: 'Acheter le forfait Pro',
    continue: 'Continuer',
    skip: 'Ignorer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    back: 'Retour',
    save: 'Enregistrer',
    add: 'Ajouter',
    added: 'Ajouté',
    done: 'Terminé',
    ok: 'OK',
    edit: 'Modifier',
    delete: 'Supprimer',
    remove: 'Retirer',
    setAsDefault: 'Définir par défaut',
    subscribeNow: "S'abonner maintenant",
    yes: 'Oui',
    preview: 'Aperçu',
    generate: 'Générer',
    changePassword: 'Changer le mot de passe',
    deleteAccount: 'Supprimer le compte',
    removeAccount: 'Retirer le compte',
    deleteProfile: 'Supprimer le profil',
    addBlock: 'Ajouter un bloc',
    copyLink: 'Copier le lien',
    active: 'Actif',
    update: 'Mettre à jour',
    updatePro: 'Mettre à niveau',
    prev: 'Précédent',
    next: 'Suivant',
    uploadImage: 'Téléverser une image',
    uploadVideo: 'Téléverser une vidéo',
    loadMore: 'Charger plus',
    uploadProductImage: "Téléverser l'image du produit",
    claim: 'Réclamer',
    removeSite: 'Supprimer le site',
    move: 'Déplacer',
    addButton: 'Ajouter un bouton',
    actionButton: "Bouton d'action",
    directMessage: 'Message direct',
    subscribe: "S'abonner",
    button: 'Bouton',
    generateWithAI: "Générer avec l'IA",
    cta: 'CTA',
    cart: 'Panier',
    direct: 'Direct',
    follow: 'Suivre',
    addNewItem: 'Ajouter un nouvel élément',
  },
  support: {
    liveSupport: 'Support en direct',
    response: 'Nous répondons généralement en 1 minute pendant les heures de travail (8h - 22h) GMT+3',
    founder: 'Denys Bilozor',
    ceo: 'Fondateur et PDG chez UniLink',
  },
  wizard: {
    createNewProfile: 'Créer un nouveau profil',
    createProfile: 'Créer le profil',
    continue: 'Continuer',
    tellUs: 'Parlez-nous de vous',
    addSocialLinks: 'Ajoutez tous les réseaux sociaux, et nous les afficherons dans votre base de données',
    addMoreLinks: 'Ajouter plus de liens',
    addLink: 'Ajouter un lien',
    selectCategory: 'Sélectionnez la catégorie qui vous décrit le mieux :',
    chooseTemplate: 'Choisir un modèle',
    skip: 'Ignorer',
    step: 'Étape',
    of: 'sur',
    yourName: 'Votre nom',
    search: 'Rechercher',
    blog: 'Blog',
    creator: 'Créateur',
    music: 'Musique',
    events: 'Événements',
    esoteric: 'Ésotérique',
    fashion: 'Mode',
    influencer: 'Influenceur',
    food: 'Alimentation',
    smallBusiness: 'Petite entreprise',
    marketing: 'Marketing',
    education: 'Éducation',
    socialMedia: 'Réseaux sociaux',
    coaching: 'Coaching',
    ecommerce: 'E-commerce',
    healthAndFitness: 'Santé et fitness',
    beautyWellness: 'Beauté et bien-être',
  },
  billing: {
    back: 'Retour',
    findPlan: 'Trouvez le forfait qui vous convient',
    changeAnytime: 'Vous pouvez changer à tout moment.',
  },
  field: {
    fullName: 'Nom complet',
    username: "nom d'utilisateur",
    addValue: 'Ajouter une valeur',
    newValue: 'Nouvelle valeur',
    placeholderDefault: 'Texte, chiffres, symboles, etc.',
    addInstagramUsername: "Ajouter le nom d'utilisateur Instagram",
    nameDefault: 'Jean',
    enterYourLink: 'Entrez votre lien',
    searchImage: 'Rechercher une image',
    pasteLink: 'Coller le lien',
    pasteLinkTip: "Ajoutez un lien vers n'importe quelle page web",
    searchGIFs: 'Rechercher des GIF',
    searchIcons: 'Rechercher des icônes',
    searchVideo: 'Rechercher une vidéo',
    search: 'Rechercher',
    insertURL: "Insérer l'URL",
    writeYourDescription: 'Rédigez votre description',
    headerCTAbutton: 'En-tête, bouton CTA',
    enterTitle: 'Entrez le titre',
    enterDescription: 'Entrez la description',
    enterURL: "Entrez l'URL canonique",
  },
  tooltip: {
    addImage: 'Ajouter une image',
    labelModalTitle: "Paramètres de l'étiquette",
    addLabel: '+ Ajouter une étiquette',
    label: 'Étiquette',
    labelCaption: "Entrez l'étiquette",
    labelText: "Texte de l'étiquette",
    labelTextCaption: "Entrez le texte de l'étiquette",
    labelTextPlaceholder: 'Étiquette',
    labelUrl: "URL de l'étiquette",
    labelUrlCaption: "Entrez l'URL de l'étiquette",
    labelUrlPlaceholder: 'https://example.com',
    noLabel: 'Aucune étiquette',
    colorFrom: 'Couleur de départ',
    colorTo: "Couleur d'arrivée",
    highlight: 'Mise en avant',
    firstName: 'Prénom',
    firstNameCaption: 'Entrez votre prénom',
    lastName: 'Nom de famille',
    lastNameCaption: 'Entrez votre nom de famille',
    jobTitle: 'Intitulé du poste',
    jobTitleCaption: 'Entrez votre intitulé de poste',
    organization: 'Organisation',
    organizationCaption: 'Entrez votre organisation',
    email: 'E-mail',
    emailCaption: 'Entrez votre e-mail',
    workPhone: 'Téléphone professionnel',
    workPhoneCaption: 'Entrez votre téléphone professionnel',
    mobilePhone: 'Téléphone mobile',
    mobilePhoneCaption: 'Entrez votre téléphone mobile',
    website: 'Site web',
    websiteCaption: 'Entrez votre site web',
    information: 'Information',
    informationCaption: 'Entrez vos informations',
    streetAddress: 'Adresse',
    streetAddressCaption: 'Entrez votre adresse',
    city: 'Ville',
    cityCaption: 'Entrez votre ville',
    state: 'État/Région',
    stateCaption: 'Entrez votre état/région',
    postalCode: 'Code postal',
    postalCodeCaption: 'Entrez votre code postal',
    country: 'Pays',
    countryCaption: 'Entrez votre pays',
    titleColor: 'Couleur du titre',
    titleColorCaption: 'Vous pouvez changer la couleur du titre',
    fontFamily: 'Famille de police',
    fontFamilyCaption: 'Vous pouvez changer la famille de police',
    fontSize: 'Taille de police',
    fontSizeLabel: "Taille de police de l'étiquette",
    fontSizeCaption: 'Vous pouvez changer la taille de police',
    fontSelect: 'Police',
    fontSelectCaption: 'Choisissez une police',
    imageMargin: "Marge de l'image",
    profilePicture: 'Photo de profil',
    profilePictureCaption: 'Changez votre photo de profil',
    pictureSize: "Taille de l'image",
    pictureSizeCaption: "Vous pouvez changer la taille de l'image",
    title: 'Titre',
    titleCaption: 'Entrez un titre',
    blockCaption: 'Entrez le titre de votre bloc',
    titlePageCaption: 'Entrez le titre de votre page',
    templates: 'Modèles',
    templatesCaption: 'Choisissez un modèle pour votre page',
    background: 'Arrière-plan',
    backgroundColor: "Couleur d'arrière-plan",
    textBackground: 'Arrière-plan du texte',
    textBackgroundCaption: "Choisir la couleur d'arrière-plan du texte",
    textColor: 'Couleur du texte',
    textColorCaption: 'Choisir la couleur du texte',
    gradientBackground: 'Arrière-plan dégradé',
    gradientColor: 'Couleur du dégradé',
    BackgroundType: 'Type',
    backgroundSource: "Source de l'arrière-plan",
    backgroundSourceCaption: "Choisissez la source de l'arrière-plan",
    backgroundStyle: "Style de l'arrière-plan",
    backgroundStyleCaption: "Choisissez le style de l'arrière-plan",
    backgroundStylesNormal: 'Normal',
    backgroundStylesGlass: 'Verre',
    backgroundStylesOutline: 'Contour',
    backgroundTypeCaption: "Choisissez le type d'arrière-plan",
    color: 'Couleur',
    colorTooltip: 'Vous pouvez changer la couleur',
    backgroundOpacityTooltip: "Faites glisser le curseur pour définir l'opacité de l'arrière-plan",
    backgroundBlur: "Flou de l'arrière-plan",
    backgroundBlurCaption: "Faites glisser le curseur pour régler le flou de l'arrière-plan",
    backgroundBrightness: "Luminosité de l'arrière-plan",
    backgroundBrightnessCaption: "Faites glisser le curseur pour changer la luminosité de l'arrière-plan",
    backgroundContrast: "Contraste de l'arrière-plan",
    backgroundContrastCaption: "Faites glisser le curseur pour changer le contraste de l'arrière-plan",
    color1: 'Couleur 1',
    color2: 'Couleur 2',
    colorCaption: 'Entrez la couleur de votre page',
    gradient: 'Dégradé',
    image: 'Image',
    photo: 'Photo',
    gif: 'GIF',
    animation: 'Animation',
    video: 'Vidéo',
    hexColor: 'Couleur hexadécimale',
    direction: 'Direction',
    gradientDirection: 'Direction du dégradé',
    directionCaption: 'Faites glisser le curseur pour définir la direction du dégradé',
    offset: 'Décalage',
    gradientOffset: 'Décalage du dégradé',
    offsetCaption: 'Faites glisser le curseur pour définir le décalage du dégradé',
    backgroundDarkness: "Obscurcissement de l'arrière-plan",
    backgroundDarknessCaption: "Faites glisser le curseur pour assombrir l'image d'arrière-plan",
    uploadVideo: 'Téléverser une vidéo',
    uploadFile: 'Téléverser un fichier',
    uploadVideoCaption: "Vidéo de l'arrière-plan de votre page",
    linkToVideo: 'Lien vers la vidéo',
    linkToVideoCaption: 'Ajoutez un lien vers la vidéo',
    videoWithSound: 'Vidéo avec son',
    videoWithSoundCaption: 'Lire la vidéo avec le son',
    fonts: 'Polices',
    fontWeight: 'Épaisseur de police',
    fontWeightCaption: 'Cliquez pour choisir votre destin',
    preloader: 'Préchargeur',
    preview: 'Aperçu',
    hideLogo: 'Masquer le logo UniLink',
    cover: 'Couverture',
    coverCaption: 'Changer la couverture',
    coverCaptionHeader: "Ajoutez une image ou une vidéo à la couverture de l'en-tête",
    pageNavigation: 'Navigation de page',
    websiteNavigation: 'Navigation par onglets',
    backgroundOpacity: "Opacité de l'arrière-plan",
    backgroundOpacityCaption: "Faites glisser le curseur pour régler l'opacité de l'arrière-plan du bouton",
    borderRadius: 'Rayon de bordure',
    borderRadiusCaption: 'Faites glisser le curseur pour définir le rayon de bordure',
    heightTabs: 'Hauteur des onglets',
    heightTabsCaption: 'Faites glisser le curseur pour définir la hauteur des onglets',
    backgroundShadow: "Ombre de l'arrière-plan",
    backgroundShape: "Forme de l'arrière-plan",
    backgroundBorder: "Bordure de l'arrière-plan",
    opacity: 'Opacité',
    opacityCaption: "Faites glisser le curseur pour définir l'opacité",
    shape: 'Forme',
    shapeCaption: 'Définir la forme',
    text: 'Texte',
    textCaption: 'Entrez le texte',
    textSize: 'Taille du texte',
    textSizeCaption: 'Faites glisser le curseur pour définir la taille du texte',
    additionalText: 'Texte supplémentaire',
    username: "Nom d'utilisateur",
    currency: 'Devise',
    language: 'Langue',
    timeZone: 'Fuseau horaire',
    websiteNiche: 'Niche du site web',
    websiteNicheCaption: 'Entrez la niche de votre site web',
    renameCaption: 'Renommer le titre du bloc',
    description: 'Description',
    descriptionCaption: 'Entrez une description',
    actionButton: "Bouton d'action",
    actionButtonCaption: "Le bouton d'appel à l'action motive les visiteurs à agir",
    animationDirection: "Direction de l'animation",
    animationDirectionCaption: "Choisissez la direction de l'animation",
    buttonTitle: 'Titre du bouton',
    buttonTitleCaption: 'Entrez le titre du bouton',
    buttonUrl: 'URL du bouton',
    buttonUrlCaption: "L'URL s'ouvrira dans une nouvelle fenêtre",
    imageSize: "Taille de l'image",
    imageSizeCaption: "Faites glisser le curseur pour définir la taille de l'image",
    view: 'Vue',
    viewCaption: 'Choisissez une vue',
    margin: 'Marge',
    marginCaption: "Faites glisser le curseur pour ajouter une marge en haut et en bas de l'élément",
    separateTopBottom: 'Haut / Bas',
    padding: 'Espacement',
    paddingCaption: "Faites glisser le curseur pour ajouter de l'espacement en haut et en bas de l'élément",
    fullWidth: 'Pleine largeur',
    lineHeight: 'Hauteur de ligne',
    lineHeightCaption: 'Vous pouvez changer la hauteur de ligne',
    button: 'Bouton',
    titleSize: 'Taille du titre',
    titleSizeCaption: 'Vous pouvez changer la taille du titre',
    titleLineHeight: 'Hauteur de ligne du titre',
    titleLineHeightCaption: 'Personnalisez la hauteur de ligne du titre pour apporter plus de solutions de design au texte',
    layout: 'Disposition',
    layoutCaption: "Créez la disposition de l'en-tête que vous souhaitez",
    layoutAlign: 'Alignement de la disposition',
    alignText: 'Aligner le texte',
    align: 'Alignement',
    alignCaption: "Choisissez l'alignement",
    position: 'Position',
    positionCaption: 'Choisissez la position',
    width: 'Largeur',
    widthCaption: 'Choisissez la largeur de votre bannière',
    nameHeader: 'Nom (laissez vide pour réinitialiser)',
    nameCaption: 'Entrez le nom de votre compte',
    shortBio: 'Courte biographie',
    shortBioCaption: 'Entrez une courte biographie de votre compte',
    externalLink: 'Lien externe',
    externalLinkCaption: 'Entrez un lien externe vers votre compte',
    location: 'Localisation',
    locationCaption: 'Entrez votre localisation',
    locationMap: 'Carte de localisation',
    locationMapCaption: "Entrez l'URL de votre localisation",
    rightIcon: 'Icône droite',
    rightIconCaption: 'Cette icône apparaîtra à droite du bouton',
    buttons: 'Boutons',
    buttonsCaption: "Ajouter des boutons d'action",
    nameLogo: 'Logo du nom',
    nameLogoCaption: 'Téléversez un logo pour votre nom',
    buttonText: 'Texte du bouton',
    buttonTextCaption: 'Entrez le nom de votre bouton',
    buttonColor: 'Couleur du bouton',
    buttonColorCaption: 'Choisissez les couleurs du bouton',
    buttonColorCTACaption: "Choisissez la couleur d'arrière-plan du bouton CTA",
    cartColor: 'Couleur du panier',
    cartColorCaption: "Choisissez la couleur d'arrière-plan du panier",
    ctaButton: 'Bouton CTA',
    ctaButtonCaption: 'Cette icône apparaîtra à droite du bouton',
    style: 'Style',
    socialIconsStyleCaption: 'Vous pouvez choisir le style de vos icônes sociales',
    socialIconsShape: 'Forme des icônes sociales',
    socialIconsShapeCaption: 'Vous pouvez choisir la forme des icônes sociales',
    headerTextColorCaption: "Vous pouvez choisir la couleur du texte de l'en-tête",
    pictureShape: "Forme de l'image",
    pictureShapeCaption: 'Vous pouvez choisir la forme de la photo de profil',
    socialLinks: 'Liens sociaux',
    socialLinksCaption: 'Ajoutez des boutons de liens sociaux pour une connexion rapide entre vous et vos clients en un clic',
    URL: 'URL',
    URLCaption: "Entrez l'adresse URL",
    heading: 'En-tête',
    headingTitle: "Titre de l'en-tête",
    headingTitleCaption: "Entrez le titre de l'en-tête",
    headingDescription: "Description de l'en-tête",
    headingDescriptionCaption: "Entrez la description de l'en-tête",
    headingImage: "Image de l'en-tête",
    headingImageCaption: 'Téléversez une image pour votre en-tête',
    headingPosition: "Position de l'en-tête",
    headingInsideBlock: "À l'intérieur du bloc",
    headingOutsideBlock: "À l'extérieur du bloc",
    headingDivider: "Séparateur d'en-tête",
    canonicalURL: 'URL canonique',
    seo: 'SEO',
    seoCaption: 'Personnalisez votre produit avec des balises méta SEO',
    themes: 'Thèmes',
    brandColors: 'Couleurs de marque',
    applyBrandColors: 'Appliquer au profil',
    syncBlocks: 'Synchroniser tous les blocs',
    brandColorsApplied: 'Couleurs de marque appliquées',
    generatedPalette: 'Palette générée',
    applying: 'Application...',
    syncing: 'Synchronisation...',
    backgroundType: "Type d'arrière-plan",
    palettes: 'Palettes',
    previewTitle: 'Titre',
    previewTitleCaption: "Saisir le titre de l'aperçu",
    previewDescription: 'Description',
    previewDescriptionCaption: "Saisir la description de l'aperçu",
    previewButton: 'Texte du bouton',
    previewButtonCaption: "Saisir le texte du bouton de l'aperçu",
    previewLabel: "Texte de l'étiquette",
    previewLabelCaption: "Saisir le texte de l'étiquette de l'aperçu",
    previewThumbnail: 'Miniature',
    previewThumbnailCaption: "Téléverser la miniature de l'aperçu",
  },
  table: {
    clicks: 'Clics',
    signups: 'Inscriptions',
    views: 'Impressions',
    orderNumber: 'Numéro de commande',
    amount: 'Montant',
    credits: 'Crédits',
    invoice: 'Facture',
    email: 'E-mail',
    card: 'Carte',
    currency: 'Devise',
    name: 'Nom',
    contact: 'Contact',
    optIn: 'Consentement',
    notes: 'Notes',
    address: 'Adresse',
    date: 'Date',
    action: 'Action',
    custom: 'Personnalisé',
    status: 'Statut',
    tags: 'Tags',
    view: 'Voir',
    remove: 'Supprimer',
    sendEmail: 'Envoyer un e-mail',
    details: 'Détails',
    purchases: 'Achats',
    order: 'Commande',
    money: 'Argent',
    type: 'Type',
    orderCode: 'Code de commande',
  },
  settings: {
    title: 'Paramètres',
    settings: 'paramètres',
    accountSettings: 'Paramètres du compte',
    email: 'E-mail',
    subscription: 'Abonnement',
    billingHistory: 'Historique de facturation',
    dueTo: 'Échéance le',
    subscriptionDueTo: "Abonnement valable jusqu'au",
    cancelSubscription: "Annuler l'abonnement",
    cancelSubscriptionConfirm: 'Êtes-vous sûr de vouloir annuler votre abonnement ?',
    subscriptionCancelled: "Votre abonnement a été annulé. Votre plan reste actif jusqu'à la fin de la période de facturation.",
    subscriptionCancelError: "Échec de l'annulation. Veuillez contacter le support.",
    deleteFirst: 'Supprimer définitivement votre',
    deleteSecond: 'et toutes ses données. Cette action est irréversible.',
    account: {
      title: 'Compte',
      usernameNotAvailable: "Le nom d'utilisateur n'est pas disponible",
      setupCustomDomain: 'Configurer un domaine personnalisé',
      subtitle: 'E-mail du compte, facturation, mot de passe et clé API',
    },
    profile: {
      title: 'Profil',
      usernameNotAvailable: "Le nom d'utilisateur n'est pas disponible",
      setupCustomDomain: 'Configurer un domaine personnalisé',
      subtitle: "Gérer le nom d'utilisateur, la langue, la devise, le fuseau horaire",
      category: 'Catégorie',
      categoryCaption: 'Entrez la catégorie de votre profil',
    },
    aiassistant: {
      title: 'Assistant IA',
      subtitle: 'Personnalisez votre assistant IA pour des réponses meilleures et plus personnalisées',
      titleText: "Aidez l'IA à comprendre qui vous êtes pour des réponses plus pertinentes",
      customAiTitle: 'Instructions personnalisées',
      customAiPlaceholder: "Ajoutez des instructions spécifiques pour l'IA...",
      customAiDescription: "Ces instructions seront appliquées à chaque conversation avec l'IA",
      nicknameTitle: "Comment l'IA doit-elle vous appeler ?",
      nicknamePlaceholder: 'Surnom',
      titleBio: 'Bio / Description',
      bioPlaceholder: 'Parlez-nous un peu de vous...',
      occupation: 'Que faites-vous ?',
      occupationPlaceholder: "ex. Étudiant en ingénierie à l'Université de Waterloo",
      aboutYouTitle: 'À propos de vous',
      aboutYouTooltip: 'Dites à votre assistant IA un peu sur vous',
      locationTitle: 'Localisation',
      locationPlaceholder: 'ex. Kyiv, Ukraine',
      categoryTitle: 'Catégorie',
    },
    notifications: {
      title: 'Notifications',
      subtitle: 'Configurez les notifications pour les nouveaux visiteurs, e-mails et commandes',
      text: 'Connectez des messageries pour recevoir des notifications sur les nouveaux e-mails et commandes de vos clients',
      setUpWebhooks: 'Configurez les webhooks dans la section Webhooks',
      save: 'Enregistrer',
      connect: 'CONNECTER',
      disconnect: 'DÉCONNECTER',
      webhook: 'Webhook',
      emailSubmit: 'Soumission de collecte de données',
      formSubmit: 'Soumission de formulaire',
      showSubmit: 'Soumission boutique',
      digitalSubmit: 'Soumission numérique',
      appointmentSubmit: 'Soumission de rendez-vous',
      requestSubmit: 'Soumission de service',
      donationSubmit: 'Soumission de don',
      email: 'E-mail',
      settings: 'paramètres',
      cartSubmit: 'Soumission du panier',
      linkClick: 'Clic sur le lien',
      contactClick: 'Clic sur le contact',
      all: 'Tous',
      updates: 'Mises à jour',
      messages: 'Messages',
      opportunities: 'Opportunités',
      insights: 'Informations',
      activity: 'Activité',
      system: 'Système',
      news: 'Actualités',
      more: 'Afficher plus',
      less: 'Afficher moins',
      connectedAccounts: 'Comptes connectés',
      addEmailAccount: 'Ajouter un compte e-mail',
    },
    paymentSystem: {
      title: 'Système de paiement',
      subtitle: 'Configurez les paiements via Stripe ou PayPal',
      text: 'Voir les frais de traitement',
      connected: 'Connecté',
      active: 'Accepter les paiements sur le site web',
      pending: 'En attente',
      disconnect: 'Déconnecter',
      connect: 'Connecter',
      add: 'Ajouter',
      ofYourAccount: 'de votre compte',
      save: 'Enregistrer',
    },
    shop: {
      title: 'Boutique',
      subtitle: 'Paramétrer les catégories et propriétés',
      label: {
        title: 'Étiquettes',
        subtitle: 'Ajoutez des étiquettes aux fiches produits',
        addValue: 'Ajouter une valeur',
        save: 'Enregistrer',
        value: 'Valeur',
        enterTitle: 'Entrez le titre',
        maximum: 'Le nombre maximum de valeurs est de 5',
        add: 'Ajouter',
        edit: 'Modifier',
        labels: 'Étiquettes',
      },
      category: {
        title: 'Catégories',
        subtitle: 'Ajoutez une catégorie à vos produits',
        addCategory: 'Ajouter une catégorie',
        save: 'Enregistrer',
        maximum: 'Le nombre maximum est de',
      },
      property: {
        title: 'Propriété',
        subtitle: 'Ajoutez une propriété à vos produits',
        addProperties: 'Ajouter des propriétés',
        properties: 'Propriétés',
        type: 'Type',
        typeTooltip: 'Type de vos propriétés',
        titleModal: 'Titre',
        titleModalTooltip: 'Nom de vos propriétés',
        enterTitle: 'Entrez le titre',
        value: 'Valeur',
        addValue: 'Ajouter une valeur',
        maximum: 'Le nombre maximum de valeurs est de',
        save: 'Enregistrer',
        cancel: 'Annuler',
        remove: 'Supprimer',
        addPropertyToItem: "Ajouter une propriété à l'élément",
        add: 'Ajouter',
        edit: 'Modifier',
        propertiesSmall: 'propriétés',
        required: 'Obligatoire',
        requiredTooltip: "Définir les propriétés obligatoires pour l'achat",
        selectAll: 'Tout sélectionner',
      },
      preorderForm: {
        title: 'Formulaire de précommande',
        subtitle: 'Configurer les champs du formulaire de précommande',
        fields: 'Champs',
        fieldsTooltip: 'Ajouter des champs au formulaire',
        required: 'Obligatoire',
        submitButton: 'Titre du bouton de soumission',
        redirectUrl: 'URL de redirection (optionnel)',
        resultText: 'Texte de résultat',
        save: 'Enregistrer',
        name: 'Nom',
        emailAddress: 'Adresse e-mail',
        phone: 'Téléphone',
        address: 'Adresse',
        comment: 'Commentaire',
      },
      shipping: {
        title: 'Livraison',
        subtitle: 'Configurer les champs de livraison',
        fields: 'Champs',
        fieldsTooltip: 'Ajouter des champs au formulaire de livraison',
        required: 'Obligatoire',
        save: 'Enregistrer',
        name: 'Nom',
        emailAddress: 'Adresse e-mail',
        phone: 'Téléphone',
        address: 'Adresse',
        comment: 'Commentaire',
        addCustomField: 'Ajouter un champ personnalisé',
        addFormInfo: 'Ajouter les informations du formulaire',
        editFormInfo: 'Modifier les informations du formulaire',
        type: 'Type',
        typeTooltip: 'Type de champ personnalisé',
        fieldName: 'Nom du champ',
        fieldNameTooltip: 'Nom du champ personnalisé',
        placeholder: 'Placeholder',
        placeholderTooltip: 'Placeholder du champ personnalisé',
        delete: 'Supprimer',
        update: 'Mettre à jour',
        add: 'Ajouter',
      },
    },
    seo: {
      title: 'SEO',
      subtitle: 'Personnalisez votre page avec des balises méta SEO',
      titleText: 'Titre',
      titlePlaceholder: 'Entrez le titre de la page',
      description: 'Description',
      descriptionPlaceholder: 'Entrez la description de la page',
      favicon: 'Favicon',
      uploadFavicon: 'Téléverser le favicon',
      imagePreview: "Aperçu de l'image",
      useCustom: 'Utiliser une image personnalisée',
      save: 'Enregistrer',
      visualise: "Visualisez l'aperçu de votre site web dans Google",
      inMessengers: 'Dans les messageries',
      inSocial: 'Sur les réseaux sociaux',
      searchEngine: 'Moteur de recherche',
      googleIndexable: 'Indexable par Google',
    },
    analytics: {
      title: 'Analytique',
      subtitle: 'Intégrez Facebook Pixel, Google Analytics et les paramètres UTM',
      facebookTooltip: 'Connectez Facebook pour afficher les analyses',
      googleAnalyticsTooltip: 'Google Analytics vous permet de mesurer le retour sur investissement de votre publicité et de suivre tous vos liens.',
      googleTagManagerTooltip: 'Google Tag Manager vous permet de configurer et de déployer instantanément des balises sur votre site web',
      tikTokPixelTooltip: "Le pixel TikTok est un outil de mesure puissant qui suit l'impact de vos publicités TikTok sur votre site web",
      pinterestTag: 'Balise Pinterest',
      pinterestTagTooltip:
        "La balise Pinterest est un morceau de code que vous ajoutez à votre site web, ce qui permet à Pinterest de suivre les visiteurs de votre site ainsi que les actions qu'ils effectuent après avoir vu votre publicité Pinterest.",
      tag: 'balise',
      headerTagTooltip: "Collez la balise qui apparaît dans l'en-tête de votre site web",
      bodyTagTooltip: 'Collez la balise qui apparaît dans le corps de votre site web',
      utmParameters: 'Paramètres UTM',
      utmParametersTooltip: 'Collectez des données de campagne avec des URL personnalisées. Ajoutez des paramètres aux URL pour identifier les campagnes qui génèrent du trafic.',
      makeAnalytics: 'Faire afficher le trafic UniLink comme Social dans Google Analytics',
      the: 'Le',
      campaign: 'paramètre de campagne',
      parameter: 'est défini dynamiquement à partir du titre de chaque publication ou lien',
      save: 'Enregistrer',
    },
    customDomain: {
      title: 'Domaine personnalisé',
      subtitle: 'Personnalisez votre page avec un domaine personnalisé',
      titleTooltip: 'Ajouter un domaine personnalisé',
      save: 'Enregistrer',
      connect: 'Connecter',
      connecting: 'Connexion en cours',
      instructions: 'Instructions',
      submit: 'Soumettre',
      submitting: 'Soumission en cours...',
      enterDomain: 'Entrez votre domaine',
      domainPlaceholder: 'votre-domaine.com',
      steps: {
        submitting: 'Soumission de la demande',
        validation: 'Validation du domaine',
        certificate: 'Provisionnement du certificat',
        complete: 'Terminé',
      },
      txtRecord: {
        title: 'Enregistrement TXT',
        description: "Ajoutez l'enregistrement TXT suivant à vos paramètres DNS :",
        verifyButton: "Vérifier l'enregistrement TXT",
        verifying: 'Vérification en cours...',
        verified: 'Enregistrement TXT vérifié',
      },
      cnameRecord: {
        title: 'Enregistrement CNAME',
        description: "Ajoutez l'enregistrement CNAME suivant à vos paramètres DNS :",
        verifyButton: "Vérifier l'enregistrement CNAME",
        verifying: 'Vérification en cours...',
        verified: 'Enregistrement CNAME vérifié',
      },
      dnsTable: {
        type: 'Type',
        host: 'Hôte',
        value: 'Valeur',
        ttl: 'TTL',
        copy: 'Copier',
        copied: 'Copié !',
      },
      provisioning: {
        title: 'Le certificat SSL est en cours de provisionnement...',
        description: 'Cela peut prendre quelques minutes. Veuillez patienter.',
        timeout: 'Le provisionnement du certificat prend plus de temps que prévu. Veuillez vérifier plus tard.',
      },
      complete: {
        title: 'HTTPS a été activé avec succès sur votre domaine.',
        connected: 'Connecté',
      },
      failed: {
        title: 'La connexion du domaine a échoué',
        tryAgain: 'Réessayer',
      },
      rootDomainWarning: "Les domaines racine nécessitent que votre fournisseur DNS prenne en charge l'aplatissement CNAME (ex. Cloudflare, Route53).",
      deleteConfirm: {
        title: 'Déconnecter le domaine',
        message: 'Êtes-vous sûr(e) de vouloir déconnecter ce domaine ? Votre site web ne sera plus accessible via ce domaine.',
        confirm: 'Déconnecter',
        cancel: 'Annuler',
      },
    },
    webhooks: {
      title: 'Webhooks',
      subtitle: "Envoyez des notifications d'événements en temps réel à des services externes",
      webhook: 'Webhook',
      webhookTooltip: 'Ajouter un webhook',
      send: 'Envoyer des événements vers un site web tiers',
      webhookUrl: 'URL du webhook (requête POST)',
      error: 'Entrez un lien correct',
      save: 'Enregistrer les modifications',
      enableWebhooks: 'Activer les webhooks',
      enableDescription: 'Requêtes POST sur les événements sélectionnés',
      endpointUrl: 'URL du point de terminaison',
      endpointTooltip: "L'URL qui recevra les requêtes POST lorsque les événements sélectionnés se produisent",
      endpointPlaceholder: 'https://example.com/api/webhook',
      events: 'Événements',
      selectAll: 'Tout sélectionner',
      deselectAll: 'Tout désélectionner',
      filterPlaceholder: 'Filtrer les événements...',
      all: 'Tous',
      none: 'Aucun',
      active: 'Actif',
      inactive: 'Inactif',
      categories: {
        submissions: 'Soumissions',
        engagement: 'Engagement',
      },
      eventLabels: {
        SubmitHeaderSubscribe: 'Abonnement en-tête',
        SubmitHeaderMessage: 'Message en-tête',
        SubmitDataCollect: 'Collecte de données',
        SubmitForm: 'Soumission de formulaire',
        SubmitShop: 'Commande boutique',
        SubmitShopPreorder: 'Précommande boutique',
        SubmitDigital: 'Produit numérique',
        SubmitAppointment: 'Rendez-vous',
        SubmitService: 'Commande de service',
        SubmitEvent: 'Inscription à un événement',
        SubmitCourse: 'Inscription à un cours',
        SubmitDonation: 'Don',
        SubmitMembership: 'Adhésion',
        SubmitBlog: 'Achat de blog',
        SubmitCoupon: 'Coupon utilisé',
        SubmitTip: 'Pourboire',
        SubmitLink: 'Achat de lien',
        SubmitProductMessage: 'Question sur le produit',
        SubmitPodcast: 'Achat de podcast',
        SubmitBooking: 'Réservation',
        SubmitRental: 'Location',
        SubmitSingleProduct: 'Produit unique',
        SubmitDiscount: 'Commande avec réduction',
        SubmitListing: 'Demande de listing',
        SubmitUnlock: 'Déverrouillage de contenu',
        SubmitChatAi: 'Message de chat IA',
        ClickLink: 'Clic sur un lien',
        ClickContact: 'Clic sur un contact',
        AddToCart: 'Ajout au panier',
        AddToCartSingleProduct: 'Produit unique au panier',
        AddToWishlist: 'Ajout aux favoris',
        InitiateCheckout: 'Initier le paiement',
        DownloadFile: 'Téléchargement de fichier',
        DownloadMusic: 'Téléchargement de musique',
        CopyCoupon: 'Copie de coupon',
        CopyDiscount: 'Copie de réduction',
        QR_ScanQrCode: 'Scan de code QR',
        VisitPage: 'Visite de page',
      },
    },
    sensitive: {
      title: 'Contenu sensible',
      subtitle: "Afficher un avertissement de contenu sensible avant d'afficher votre site web",
    },
    socialIntegration: {
      title: 'Intégration sociale',
      subtitle: 'Gérez vos intégrations Instagram, TikTok',
      connectInstagram: 'Connecter Instagram',
    },
    emailIntegration: {
      title: "Intégrations d'audience",
      subtitle: 'Transmettez les adresses e-mail de vos visiteurs à MailChimp, Reply',
      emailCaption: 'Ajoutez une intégration pour transmettre les adresses e-mail de vos abonnés à MailChimp',
      mailChimp: 'Intégrations MailChimp',
      selzy: 'Intégrations Selzy',
      selzyCaption: 'Ajoutez une clé API pour transmettre les adresses e-mail de vos abonnés à Selzy',
      sendPulse: 'Intégrations SendPulse',
      sendPulseCaption: 'Ajoutez une clé API pour transmettre les adresses e-mail de vos abonnés à SendPulse',
      reply: 'Intégrations Reply',
      replyCaption: 'Ajoutez une clé API pour transmettre les adresses e-mail de vos abonnés à',
      integrations: 'intégrations',
    },
    calendarIntegration: {
      title: 'Calendar integrations',
      subtitle: 'Connect your calendar services',
      calendly: 'Calendly',
      calendlyDescription: 'Connect Calendly to sync your event types and availability',
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: 'Connect Google Calendar to sync events and create Google Meet links',
      zoom: 'Zoom',
      zoomDescription: 'Connect Zoom to create meeting links automatically',
      googleMeet: 'Google Meet',
      googleMeetDescription: 'Create Google Meet links automatically (requires Google Calendar)',
    },
    storage: {
      title: 'Stockage',
      subtitle: 'Enregistrez les commandes des visiteurs dans Google Spreadsheet',
      storageCaption: 'Ajoutez une intégration pour enregistrer toutes les commandes de vos clients dans Google Spreadsheet',
      emailSignup: 'Inscription par e-mail',
      emailSignupsCaption: 'Choisissez un tableau pour enregistrer les inscriptions par e-mail',
      formSignups: 'Inscription par formulaire',
      forSignupsCaption: 'Choisissez un tableau pour enregistrer les inscriptions par formulaire',
      shopOrders: 'Commandes de la boutique',
      shopOrderCaption: 'Choisissez un tableau pour enregistrer les commandes de la boutique',
      disconnect: 'Déconnecter le tableur',
      storageUsage: 'Utilisation du stockage',
      of: 'de',
      uses: 'Cette application utilise',
      space: 'de votre espace disque gratuit',
      view: 'voir les détails',
      noItems: "Il n'y a aucun élément",
      files: 'Fichiers',
      images: 'Images',
      videos: 'Vidéos',
      audio: 'Audio',
      settings: 'paramètres',
    },
  },
  productStore: {
    title: "Afficher l'onglet Boutique sur votre lien en bio",
    subtitle: 'Votre boutique est actuellement masquée.',
  },
  sections: {
    splashScreen: {
      title: 'Écran de démarrage',
      subtitle: "S'affiche pendant le chargement de la page",
    },
    promo: {
      title: 'Barre promotionnelle',
      subtitle: "Mise en avant qui vous permet d'afficher des promotions",
      masterPromoMessage:
        "La barre promotionnelle principale est actuellement activée. Si vous souhaitez créer une barre promotionnelle personnalisée pour cette page, vous devez d'abord désactiver la barre promotionnelle principale.",
      titlePlaceholder: 'Bienvenue sur mon site web !',
      switcherIsMasterPromobar: 'Afficher sur toutes les pages',
    },
    contact: {
      title: 'Contacts',
      subtitle: 'Fournissez un moyen de communiquer avec vous',
      caption: 'Ajoutez des boutons de messagerie pour une connexion rapide entre vous et vos clients en un clic',
      tooltip: 'Les contacts permettent aux utilisateurs de communiquer directement avec vous. Ajoutez votre téléphone, e-mail, messagerie ou localisation',
      addNewContact: 'Ajouter un nouveau contact',
      addContact: 'Ajouter un contact',
      chooseContact: 'Choisir un contact',
      enterLink: 'Entrez le lien de votre contact',
      showDetails: 'Afficher les détails',
      enterAnyContact: 'Veuillez entrer un contact',
      enterAnyContactCaption: '(WhatsApp, Telegram, Viber, Messenger)',
    },
    membership: {
      title: 'Adhésion',
      subtitle: 'Créez un abonnement gratuit ou payant à votre contenu',
      addNewTier: 'Ajouter un nouveau niveau',
      editTier: 'Modifier le niveau',
      name: 'Nom',
      nameCaption: 'Entrez le nom de votre niveau',
      price: 'Prix par mois',
      priceCaption: 'Entrez le prix de votre niveau',
      month: 'mois',
      image: 'Image',
      imageCaption: 'Téléversez une image pour votre niveau',
    },
    pricing: {
      title: 'Tarification',
      subtitle: 'Créez un menu avec des prix',
      add: 'Ajouter un nouvel élément',
      edit: "Modifier l'élément",
      name: 'Nom',
      nameCaption: 'Entrez le nom de votre élément',
      duration: 'Attribut',
      durationCaption: 'Entrez le temps, la quantité ou la durée de votre élément',
      category: 'Catégorie',
      categoryCaption: 'Entrez la catégorie de votre élément',
      price: 'Prix',
      priceCaption: 'Entrez le prix de votre élément',
      month: 'mois',
      image: 'Image',
      imageCaption: 'Téléversez une image pour votre élément',
    },
    subscribe: {
      dataCollectTitle: 'Collecte de données',
      title: "S'abonner",
      subtitle: 'Collectez les e-mails ou numéros de téléphone de vos visiteurs',
      instructionsMessage: "Ajoutez un champ d'inscription par e-mail à votre page pour que vos visiteurs puissent facilement s'inscrire !",
      instructionsLink: 'Transmettez les e-mails à MailChimp pour lancer des campagnes marketing.',
      sectionHeaderCaption: 'Abonnez-vous à notre newsletter',
      collecting: 'Collecte',
      collectingCaption: 'Choisissez votre type de saisie',
      addDataToCollect: 'Ajouter des données à collecter',
      email: 'E-mail',
      enterEmail: "Entrez l'e-mail",
      thanksForEmail: 'Merci pour votre e-mail',
      phone: 'Téléphone',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'YouTube',
      whatsapp: 'WhatsApp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: 'Ajouter des liens mis à jour',
      placeholder: 'Placeholder',
      placeholderCaption: 'Entrez le texte du placeholder',
      button: 'Bouton',
      buttonCaption: 'Texte qui motivera le visiteur à entrer son e-mail (réduction de 10%, abonnez-vous maintenant, téléchargez le fichier, etc.)',
      submitButton: 'Bouton de soumission',
      enterButton: 'Entrez le bouton',
      thanksMessage: 'Message de remerciement',
      thanksMessageCaption: 'Message de remerciement pour vos abonnés',
      resultAction: 'Action (après soumission)',
      resultActionCaption: 'Action après avoir rempli le formulaire',
      sendAnEmail: 'Envoyer un e-mail',
      downloadFile: 'Télécharger un fichier',
      redirect: 'Redirection',
      messageBody: 'Corps du message',
      messageBodyCaption: "Ces données seront envoyées à l'e-mail de l'utilisateur en cadeau pour son inscription (coupon, lien de téléchargement, etc.)",
      integration: 'Intégration',
      integrationCaption: 'Transmettez les adresses e-mail de vos visiteurs à MailChimp, Reply',
      storage: 'Stockage',
      storageCaption: 'Enregistrez les commandes des visiteurs dans Google Spreadsheet',
      maxSize: 'Vous pouvez ajouter un maximum de 3 canaux',
    },
    text: {
      title: 'Texte',
      subtitle: "Écrivez n'importe quoi sur vous/votre entreprise",
      trimBio: 'Bouton Voir plus',
    },
    header: {
      title: 'En-tête',
      subtitle: 'Image ou vidéo agrandie en vedette sur votre page',
      verifiedBadge: 'Badge vérifié',
      showProfilePic: 'Afficher la photo de profil',
      profilePicRatio: 'Ratio',
      profilePicRatioSquare: 'Carré',
      profilePicRatioLandscape: 'Paysage',
      profilePicRatioPortrait: 'Portrait',
      namePlaceholder: 'Votre nom',
      shortBioPlaceholder: 'Ma courte présentation',
      externalLinkPlaceholder: 'URL',
      locationPlaceholder: 'Ville',
      addSocial: '+ Ajouter un réseau social',
      addCover: '+ Ajouter une couverture',
      addButton: '+ Ajouter un bouton',
      addText: '+ Ajouter du texte',
      addLabel: '+ Ajouter une étiquette',
      subtitleName: "Personnalisez l'apparence de votre nom",
      subtitleShortBio: "Personnalisez l'apparence de votre courte biographie",
      shortBioSize: 'Taille de la courte biographie',
      subtitleShortBioSize: 'Vous pouvez changer la taille de la courte biographie',
      subtitleLocation: 'Définissez la ville/le pays pour guider les visiteurs vers un lieu spécifique',
      headerCoverWarningMessage: 'Votre navigateur ne prend pas en charge la balise vidéo.',
      headerCoverTitle: "Définir la couverture au-dessus de l'en-tête",
      coverHeight: 'Hauteur de la couverture',
      subtitleCoverHeight: 'Vous pouvez changer la hauteur de la couverture',
      coverDarkness: 'Obscurcissement de la couverture',
      subtitleCoverDarkness: "Faites glisser le curseur pour assombrir l'image de couverture",
      nameSize: 'Taille du nom',
      subtitleNameSize: 'Vous pouvez changer la taille du nom',
      positionText: 'Position du nom',
      subtitlePositionName: 'Faites glisser le curseur pour définir la position du nom',
      positionContent: 'Position du contenu',
      subtitlePositionContent: 'Définissez la position pour la bio, le lien, la localisation',
      coverText: 'Texte sur la couverture',
      subtitleCoverText: 'Ajoutez du texte à votre couverture',
      position: 'Position',
      subtitlePosition: 'Faites glisser le curseur pour définir la position du bouton',
      buttonCover: 'Bouton sur la couverture',
      subtitleButtonCover: 'Ajoutez un bouton à votre couverture en choisissant une action',
      subtitleFollow: 'Le bouton Suivre permet aux utilisateurs de suivre vos actualités',
      buttonOpacity: "Faites glisser le curseur pour changer l'opacité du bouton",
      subtitleCart: "Icône du panier pour offrir une expérience d'achat",
      subtitleDirect: 'Bouton rapide pour diriger le visiteur vers les messageries',
      subtitleCTAButton: "Bouton (appel à l'action) qui motive l'utilisateur à cliquer",
      subtitleSocialLinks: 'Donnez un aspect visuel à vos réseaux sociaux',
      chooseSocialLink: 'Choisir un lien social',
      alignSocialLink: 'Alignement des liens sociaux',
      enterYourSocialLink: 'Entrez votre lien social',
      blockShadow: 'Ombre du bloc',
      activeButtonPosition: 'Position du bouton actif',
      gradientColor: 'Couleur du dégradé',
      bottomGradient: 'Dégradé du bas',
      autoGradient: 'Auto',
      customGradient: 'Personnalisé',
      uploadLogo: 'Téléverser le logo',
      customBackground: 'Arrière-plan personnalisé',
      headingLabel: "Étiquette de l'en-tête",
      customizeLabel: "Personnalisez l'apparence de l'étiquette de l'en-tête",
      labelText: "Texte de l'étiquette",
      enterLabelText: "Entrez le texte de l'étiquette de l'en-tête",
    },
  },
  billingHistory: {
    title: 'Historique de facturation',
    invoices: 'Factures',
    messageText: "Vous n'avez pas encore d'historique de paiement.",
  },
  migrate: {
    title: 'Avez-vous LinkTree ou Taplink ?',
    text: 'Collez le lien et migrez vers UniLink en un seul clic !',
    button: 'Migrer',
  },
  pages: {
    title: 'Pages',
    addPage: 'Ajouter une page',
    addNewPage: 'Ajouter une nouvelle page',
    deleteTitle: 'Êtes-vous sûr(e) de vouloir supprimer cette page ?',
    managePage: 'Gérer les onglets',
    empty: "Cette page n'a pas encore de bloc.",
    dragAndDrop: 'Faites glisser et déposez vos autres onglets pour les réorganiser',
    pageNavigation: 'Paramètres de navigation des pages',
    goToDesign: 'Aller aux paramètres de design',
    viewArchive: 'Voir les archives',
    archivedBlocks: 'Blocs archivés',
    noArchivedBlocks: "Gardez votre page propre et organisée en archivant les blocs que vous n'utilisez pas actuellement.",
    archiveAllUnpublished: 'Archiver tous les blocs non publiés',
    restore: 'Restaurer',
    permanentDelete: 'Supprimer définitivement',
  },
  analytics: {
    lifeTimeAnalytics: 'Analytique globale',
    impressions: 'Impressions',
    impressionsText: "Performance des statistiques d'impressions pour la période choisie",
    clicks: 'Clics',
    clicksText: 'Performance des événements "clic" pour la période choisie',
    signUps: 'Inscriptions',
    signUpsText: 'Performance des événements "fermeture" pour la période choisie',
    totalInteractions: 'Interactions',
    totalInteractionsText: 'Clics et inscriptions via formulaire pour la période choisie',
    engagementRate: "Taux d'engagement",
    engagementRateText: 'Part des vues de profil ayant mené à une interaction',
    visitor: 'Sources de visiteurs',
    country: 'Pays',
    countries: 'Pays',
    linkClicks: 'Clics sur les liens',
    content: 'Contenu',
    views: 'Vues',
  },
  aiInsights: {
    title: 'Insights IA',
    generate: 'Analyser mon profil',
    description: "Obtenez des recommandations basées sur l'IA pour améliorer les performances de votre profil.",
    analyzing: 'Analyse de votre profil...',
    refresh: 'Actualiser',
    action: 'Action',
  },
  post: {
    subscriptionTypePlaceholder: "Disponible pour l'abonnement '{type}' et supérieur",
    postButtonText: 'Publier',
    newPostPlaceholder: "Qu'avez-vous en tête",
    free: 'Gratuit',
    pro: 'Pro',
    premium: 'Premium',
    noPost: "Vous n'avez pas encore de publications",
    editPost: 'Modifier la publication',
  },
  preview: {
    buy: 'Acheter',
    connect: 'Connecter',
  },
  activeButton: {
    initialText: 'Site web',
    inputPlaceholder: 'Rechercher des actions...',
    existing: 'Existant',
    redirect: 'Redirection',
    scroll: 'Défilement',
    title: 'Bouton actif',
    modalTitle: 'Action du bouton actif',
    subtitle: "Bouton qui motive l'utilisateur à effectuer une action",
    next: 'Suivant',
    save: 'Enregistrer',
    opensALinkFromLinksBlock: 'Ouvre un lien du bloc Liens',
    url: 'URL',
    opensAWebsite: 'Ouvre un site web',
    openInApp: "Ouvrir dans l'application",
    addAction: 'Ajouter une action',
    actionTitle: 'Action',
    actionCaption: "Modifier le type d'action",
    chooseOption: 'Choisissez une option',
    tellPeople: "Indiquez aux utilisateurs comment interagir avec le bouton d'action",
    urlRedirect: 'Redirection URL',
    customUrl: 'URL personnalisée',
    customUrlText: 'Ouvre un site web',
    links: 'Liens',
    linksText: 'Ouvre un lien depuis le bloc Liens',
    downloadDocument: 'Télécharger le document',
    sendEmail: 'Envoyer un e-mail',
    opensEmailClient: 'Ouvre le client de messagerie',
    phoneCall: 'Appel téléphonique',
    initiatesPhoneCall: 'Lance un appel téléphonique',
    navigation: 'Navigation',
    openPage: 'Ouvrir la page',
    opensInternalPage: 'Ouvre une page interne',
    openPageText: 'Ouvre une page interne',
    openProduct: 'Ouvrir le produit',
    openProductText: 'Ouvre la page produit depuis la boutique',
    openBlog: 'Ouvrir le blog',
    opensBlogPageFromStore: 'Ouvre la page de blog depuis la boutique',
    openBlock: 'Ouvrir le bloc',
    opensContentBlock: 'Ouvre le bloc de contenu',
    openItem: "Ouvrir l'élément",
    opensItemPageFromStore: "Ouvre la page de l'élément depuis la boutique",
    showNewModal: 'Afficher la nouvelle modale',
    displayContentInModalWindow: 'Afficher le contenu dans une fenêtre modale',
    showProduct: 'Afficher le produit',
    displayProductInModalWindow: 'Afficher le produit dans une fenêtre modale',
    showBlog: 'Afficher le blog',
    scrollToBlock: 'Défiler vers le bloc',
    scrollToBlockText: 'Défiler vers le bloc de page spécifié',
    scrollToItem: "Faire défiler jusqu'à l'élément",
    action: 'Action',
    showBlock: 'Afficher le bloc',
    showBlockText: 'Afficher le bloc dans une fenêtre modale sur la page',
    showItem: "Afficher l'élément",
    showItemText: "Afficher le bloc d'élément dans une fenêtre modale sur la page",
    linksCaption: 'Liens',
    linksTooltip: 'Choisissez un lien depuis le bloc de liens',
    pagesCaption: 'Pages',
    pagesTooltip: 'Choisissez une page parmi les pages',
    productsCaption: 'Produits',
    productsTooltip: 'Choisissez un produit dans la liste',
    blocksCaption: 'Blocs',
    blocksTooltip: 'Choisissez un bloc dans la liste',
    itemsCaption: 'Éléments',
    itemsTooltip: 'Choisissez un élément dans la liste',
    showProductText: 'Afficher le produit dans une fenêtre modale sur la page',
    more: 'Afficher plus',
    less: 'Afficher moins',
    showNewModalTitle: 'Données de la nouvelle modale',
    uploadDocumentTitle: 'Cliquez pour téléverser ou glissez-déposez',
    uploadProgressTitle: 'Téléversement...',
    haveNoModal: "Vous n'avez aucune modale",
    haveModal: 'Vous avez sélectionné une modale',
    openNewModalHandler: 'Créer une nouvelle modale',
    linkGroupSubTitle: 'Sélectionner un bloc',
    linkItemSubTitle: 'Sélectionner un lien',
    urlItemSubTitle: 'URL du site web',
    openInAppItemSubTitle: "URL de l'application",
    sendEmailItemSubTitle: 'Adresse e-mail',
    phoneCallItemSubTitle: 'Numéro de téléphone',
    openPageGroupSubTitle: 'Sélectionner une page',
    openPageItemSubTitle: 'Sélectionner une page',
    openProductGroupSubTitle: 'Sélectionner le type de produit',
    openProductItemSubTitle: 'Sélectionner un produit',
    openBlogGroupSubTitle: 'Sélectionner une chaîne de blog',
    openBlogItemSubTitle: 'Sélectionner un article de blog',
    openBlockGroupSubTitle: 'Sélectionner une page',
    openBlockItemSubTitle: 'Sélectionner un bloc',
    openItemGroupSubTitle: 'Sélectionner un bloc',
    openItemItemSubTitle: 'Sélectionner un élément',
    showProductGroupSubTitle: 'Sélectionner le type de produit',
    showProductItemSubTitle: 'Sélectionner un produit',
    showBlogGroupSubTitle: 'Sélectionner une chaîne de blog',
    showBlogItemSubTitle: 'Sélectionner un article de blog',
    showBlockGroupSubTitle: 'Sélectionner une page',
    showBlockItemSubTitle: 'Sélectionner un bloc',
    showItemGroupSubTitle: 'Sélectionner un bloc',
    showItemItemSubTitle: 'Sélectionner un élément',
    scrollToBlockGroupSubTitle: 'Sélectionner une page',
    scrollToBlockItemSubTitle: 'Sélectionner un bloc',
    scrollToItemGroupSubTitle: 'Sélectionner un bloc',
    scrollToItemItemSubTitle: 'Sélectionner un élément',
    linkGroupPlaceholder: 'Choisir un bloc...',
    linkItemPlaceholder: 'Choisir un lien...',
    openPageItemPlaceholder: 'Choisir une page...',
    openProductGroupPlaceholder: 'Choisir un type de produit...',
    openProductItemPlaceholder: 'Choisir un produit...',
    showProductGroupPlaceholder: 'Choisir un groupe de produits...',
    showProductItemPlaceholder: 'Choisir un produit...',
    openBlogGroupPlaceholder: 'Choisir une chaîne de blog...',
    openBlogItemPlaceholder: 'Choisir un article de blog...',
    openBlockGroupPlaceholder: 'Choisir une page...',
    openBlockItemPlaceholder: 'Choisir un bloc...',
    openItemGroupPlaceholder: 'Choisir une page et un bloc...',
    openItemItemPlaceholder: 'Choisir un élément...',
    showBlogGroupPlaceholder: 'Choisir un groupe de blog...',
    showBlogItemPlaceholder: 'Choisir un article de blog...',
    showBlockGroupPlaceholder: 'Choisir une page...',
    showBlockItemPlaceholder: 'Choisir un bloc...',
    showItemGroupPlaceholder: 'Choisir une page et un bloc...',
    showItemItemPlaceholder: 'Choisir un élément...',
    scrollToBlockGroupPlaceholder: 'Choisir une page...',
    scrollToBlockItemPlaceholder: 'Choisir un bloc...',
    scrollToItemGroupPlaceholder: 'Choisir une page et un bloc...',
    scrollToItemItemPlaceholder: 'Choisir un élément...',
    linkReadable: 'Lien',
    urlReadable: 'URL',
    openInAppReadable: "Ouvrir dans l'app",
    downloadDocumentReadable: 'Télécharger le document',
    sendEmailReadable: 'Envoyer un e-mail',
    phoneCallReadable: 'Appel téléphonique',
    openPageReadable: 'Ouvrir la page',
    openProductReadable: 'Ouvrir le produit',
    showNewModalReadable: 'Afficher une nouvelle fenêtre',
    showProductReadable: 'Afficher le produit',
    openBlogReadable: 'Ouvrir le blog',
    openBlockReadable: 'Ouvrir le bloc',
    openItemReadable: "Ouvrir l'élément",
    showBlogReadable: 'Afficher le blog',
    showBlockReadable: 'Afficher le bloc',
    showItemReadable: "Afficher l'élément",
    scrollToBlockReadable: "Défiler jusqu'au bloc",
    scrollToItemReadable: "Défiler jusqu'à l'élément",
  },
  design: {
    tabs: 'Onglets',
    imageView: "Vue de l'image",
    preview: 'Aperçu',
    buttonOpacity: 'Opacité du bouton',
    buttonBorder: 'Bordure du bouton',
    buttonShadow: 'Ombre du bouton',
    itemView: "Vue de l'élément",
    itemViewTooltip: "Choisissez la vue de l'élément",
    itemLayout: "Disposition de l'élément",
    itemLayoutTooltip: "Choisissez la disposition de l'élément",
    top: 'Haut',
    center: 'Centre',
    bottom: 'Bas',
    bottomLeft: 'Bas gauche',
    bottomHorizontal: 'Bas horizontal',
    under: 'Dessous',
    title: 'Titre',
    titleButton: 'Titre et bouton',
    displayOptions: "Options d'affichage",
    displayOptionsTooltip: "Choisissez les options d'affichage",
    landscape: 'Paysage',
    square: 'Carré',
    portrait: 'Portrait',
    desktopMode: 'Mode bureau',
    mobile: 'Compact',
    desktop: 'Large',
    responsive: 'Responsive',
    custom: 'Personnalisé',
    templates: 'Modèles',
    chooseTemplates: 'Choisissez vos modèles',
    viewAll: 'Tout voir',
    previousTheme: 'Veuillez noter que le thème précédent sera définitivement effacé.',
    useThisTemplate: 'Utiliser ce modèle',
    notSupportedVideo: 'Votre navigateur ne prend pas en charge la balise vidéo.',
    photosBy: 'Photos par',
    animationBy: 'Animation par',
    searchTheSame: 'Recherchez le même terme à nouveau pour des résultats différents.',
    addImage: 'Ajouter une image',
    addVideo: 'Ajouter une vidéo',
    orSelectFrom: 'ou sélectionnez depuis',
    noImagesYet: 'Aucune image pour le moment',
    noVideosYet: 'Aucune vidéo pour le moment',
    videoBy: 'Vidéo par',
    hamburgerMenu: 'Menu hamburger',
    tabsOnTop: 'Onglets en haut',
    tabsOnBottom: 'Onglets en bas',
    borderType: 'Type de bordure',
    subTitle: "Choisissez la forme, le type de bordure, l'ombre, etc.",
    icon: 'Icône',
    iconTooltip: 'Choisissez la bonne icône pour votre bouton',
    background: 'Arrière-plan',
    color: 'Couleur',
    backgroundOpacity: "Opacité de l'arrière-plan",
    backgroundOpacityTooltip: "Faites glisser le curseur pour définir l'opacité de l'arrière-plan",
    gradient: 'Dégradé',
    color1: 'Couleur 1',
    color2: 'Couleur 2',
    direction: 'Direction',
    directionTooltip: 'Faites glisser le curseur pour définir la direction du dégradé',
    offset: 'Décalage',
    offsetTooltip: 'Faites glisser le curseur pour définir le décalage du dégradé',
    minHeight: 'Hauteur minimale',
    minHeightTooltip: 'Faites glisser le curseur pour changer la hauteur minimale du bouton',
    align: 'Alignement',
    alignTooltip: 'Changer la position du bouton',
    insert: "Insérer l'URL",
    upload: 'Téléverser une vidéo',
    search: 'Rechercher une vidéo',
    layout: 'Disposition',
    layoutTooltip: 'Choisissez la disposition que vous souhaitez',
    view: 'Vue',
    viewTooltip: 'Choisissez la vue que vous souhaitez',
    media: 'Média',
    mediaTooltip: 'Choisissez le média que vous souhaitez',
    none: 'Aucun',
    small: 'Petit',
    medium: 'Moyen',
    large: 'Grand',
    round: 'Rond',
    feed: 'Flux',
    slider: 'Carrousel',
    text: 'Texte',
    colorTooltip: 'Choisissez les couleurs',
    button: 'Bouton',
    buttonTooltip: 'Choisissez les couleurs du bouton',
    chooseEmoji: 'Choisir un émoji',
    changeEmoji: 'Changer votre émoji',
    quantum: 'Quantum',
    emoji: 'Émoji',
    warp: 'Warp',
  },
  components: {
    quickAdd: {
      addLink: 'Ajouter un lien',
      addVideo: 'Ajouter une vidéo',
      addProduct: 'Ajouter un produit',
      addPost: 'Ajouter une publication',
      addArticle: 'Ajouter un article',
      addPhoto: 'Ajouter une photo',
      addMusic: 'Ajouter de la musique',
      addFiles: 'Ajouter des fichiers',
      addStory: 'Ajouter une story',
    },
    emoji: {
      search: 'Rechercher',
      clear: 'Effacer',
      notfound: 'Aucun émoji trouvé',
      skintext: 'Choisissez votre teinte de peau par défaut',
      categories: {
        search: 'Résultats de recherche',
        recent: 'Fréquemment utilisés',
        smileys: 'Émoticônes et émotions',
        people: 'Personnes et corps',
        nature: 'Animaux et nature',
        foods: 'Nourriture et boissons',
        activity: 'Activité',
        places: 'Voyages et lieux',
        objects: 'Objets',
        symbols: 'Symboles',
        flags: 'Drapeaux',
        custom: 'Personnalisé',
      },
      categorieslabel: "Catégories d'émojis",
      skintones: {
        1: 'Teinte de peau par défaut',
        2: 'Teinte de peau claire',
        3: 'Teinte de peau moyennement claire',
        4: 'Teinte de peau moyenne',
        5: 'Teinte de peau moyennement foncée',
        6: 'Teinte de peau foncée',
      },
    },
    blogPreviewModal: {
      title: 'Aperçu du blog',
      notify: 'Notifier les abonnés',
    },
    standAloneModal: {
      title: 'Aperçu du lien',
      save: 'Enregistrer',
      chooseLayout: 'Choisissez une disposition pour votre lien',
      linkSettings: 'Paramètres du lien',
      linkSettingsSubtitle: 'Redirection, apparence',
      whenVisitorsClicks: 'Quand un visiteur clique sur ce lien :',
      redirect: 'Redirection',
      redirectText: "Envoyer les visiteurs directement vers l'URL",
      highlight: 'Mise en avant',
      highlightText: 'Envoyer les visiteurs vers votre UniLink et mettre en avant',
      standalone: 'Autonome',
      standaloneText: 'Faites ressortir votre lien YouTube et jouez le contenu directement sur votre',
      cover: 'Couverture',
      imageTab: 'Image',
      videoTab: 'Vidéo',
      uploadImage: 'Téléverser une image',
      whenVisitors: 'Quand un visiteur sélectionne le lien partagé :',
      compact: 'Vue compacte',
      fullView: 'Vue complète',
      videoSound: 'Lire la vidéo avec le son',
    },
    instagramModal: {
      title: 'Envoyez des DM Instagram automatiques',
      subtitle: "Envoyez ce lien par message direct lorsque quelqu'un commente votre publication ou Reel IG",
      promo: 'Choisissez depuis quel IG vous souhaitez envoyer',
      connect: 'Connecter un compte Instagram',
      added: 'Compte Instagram ajouté',
      addNew: 'Ajouter une nouvelle automatisation',
      igContent: 'Contenu IG',
      trigger: 'Déclencheur',
      dmContent: 'DM',
      linkDestination: 'Destination du lien',
      buttonTitle: 'Titre du bouton',
      buttonTitleTooltip: 'Entrez le titre du bouton',
      directMessage: 'Message direct',
      directMessageTooltip: 'Entrez le message direct',
      selectPosts: 'Sélectionnez la publication ou le Reel qui déclenchera votre DM automatique.',
      onePost: 'Une publication ou un Reel spécifique',
      allPosts: 'Toutes les publications ou Reels',
      triggerText: 'Quand les commentaires incluent ceci, votre DM sera envoyé.',
      addMessage: 'Ajoutez un message à envoyer automatiquement avec votre lien.',
      clickLink: "Quand quelqu'un clique sur le lien dans votre DM :",
      anyComment: "N'importe quel commentaire",
      specificKeywords: 'Commentaires avec des mots-clés spécifiques',
      sendLink: 'Les envoyer vers votre UniLink et mettre en avant ',
      skipLink: 'Ignorer UniLink et les envoyer directement',
      keywordsTitle: 'Commentaires avec des mots-clés spécifiques',
      keywordsText: 'Vos DM seront envoyés lorsque les commentaires incluent ou excluent\ndes mots-clés spécifiques (non sensible à la casse) :',
      keywordsPlaceholder: 'Tapez un mot-clé',
      keywordsExclude: 'Exclure des mots-clés',
      keywordsExcludeText: "Doit exclure l'un de ceux-ci",
      replyComment: 'Répondre au commentaire',
      replyCommentTooltip: 'Entrez la réponse au commentaire',
    },
    blockEditProduct: {
      productPreview: 'Aperçu du produit',
      productDetails: 'Détails du produit',
      settings: 'Paramètres',
      design: 'Design',
    },
    editMenuItems: {
      overview: "Vue d'ensemble",
      analytics: 'Analytique',
    },
    botToken: {
      bot: 'Bot',
      botTooltip: 'Entrez le token de votre bot',
      connect: 'Connecter',
      token: 'Token',
    },
    rewards: {
      title: 'Titre',
      titleTooltip: 'Entrez le titre de la réponse',
      text: 'Texte',
      textTooltip: 'Entrez le texte de la réponse',
      link: 'Lien',
      linkTooltip: 'Entrez le lien de la réponse',
      code: 'Code',
      codeTooltip: 'Entrez le code de la réponse',
      files: 'Fichiers',
      filesTooltip: 'Entrez les fichiers de la réponse',
      removeReward: 'Êtes-vous sûr(e) de vouloir supprimer cette réponse ?',
    },
    addRewardModal: {
      addReward: 'Ajouter une réponse',
      textTitle: 'Texte',
      textText: "Donnez accès à des instructions ou à du texte avec l'éditeur riche",
      fileTitle: 'Fichiers',
      fileText: 'Donnez accès à des fichiers et collectez les coordonnées',
      linkTitle: 'Lien',
      linkText: 'Donnez accès à du contenu exclusif et collectez les coordonnées',
      codeTitle: 'Code',
      codeText: 'Donnez accès à des promotions exclusives et collectez les coordonnées',
    },
    blockEmpty: {
      isNotAdded: "n'est pas ajouté",
      itSeems: 'Il semble que votre',
      itemsNot: 'éléments ne sont pas encore ajoutés. Ajoutez vos vidéos maintenant',
      add: 'Ajouter',
    },
    blockList: {
      add: 'Ajouter',
      item: 'élément',
    },
    submitAction: {
      action: 'Action (après soumission)',
      actionTooltip: 'Choisissez une action après la soumission',
      upload: 'Téléverser des pièces jointes',
      none: 'Aucune',
      page: 'Afficher la page de confirmation',
      email: 'Envoyer un e-mail de confirmation',
      redirect: "Rediriger vers l'URL",
    },
    blockEditItem: {
      content: 'Contenu',
      preview: 'Aperçu',
      settings: 'Paramètres',
    },
    domainButton: {
      customizeDomain: 'Personnalisez votre domaine.',
      upgradeToLink: 'Passez au forfait Pro Lien en bio et utilisez un domaine personnalisé.',
    },
    coverText: {
      text: 'Texte',
      textTooltip: 'Entrez le texte de votre couverture',
      description: 'Description',
      descriptionTooltip: 'Entrez la description de votre couverture',
      textColor: 'Couleur du texte',
    },
    itemModal: {
      edit: 'Modifier',
      addNew: 'Ajouter un nouvel',
      item: 'élément',
      update: 'Mettre à jour',
      add: 'Ajouter',
    },
    viewDesign: {
      compact: 'Compact',
      card: 'Carte',
      button: 'Bouton',
      list: 'Liste',
      hero: 'Hero',
      featured: 'En vedette',
    },
    moveItemModal: {
      title: "Déplacer l'élément vers une autre page",
      cancel: 'Annuler',
      move: 'Déplacer',
      page: 'Page',
      pageTooltip: "Choisissez une page pour déplacer l'élément",
      blocks: 'Blocs',
      blocksTooltip: "Choisissez un bloc pour déplacer l'élément",
      emptyBlocks: "Il n'y a pas de blocs requis sur cette page.",
    },
    limitModal: {
      title: 'Limite atteinte',
      text1: 'Vous avez atteint la limite de votre site.',
      text2: 'Veuillez nous contacter pour mettre à niveau votre forfait.',
      close: 'Fermer',
    },
    cropPicture: {
      title: 'Recadrer votre image',
      cancel: 'Annuler',
      save: 'Enregistrer',
    },
    uploadFile: {
      uploadProductImage: "Téléverser l'image du produit",
      coverImage: 'Image de couverture',
      uploadImages: 'Vous ne pouvez téléverser que des images ici',
    },
    userMediaLibrary: {
      addImage: 'Ajouter une image',
      uploadImage: 'Téléverser une image',
      orSelectFrom: 'ou téléverser',
      orSelectLink: 'ou coller le lien',
      myMedia: 'Mes médias',
      stockImages: 'Images stock',
      gifs: 'GIF',
      icons: 'Icônes',
      noImagesYet: 'Aucune image pour le moment',
      loadMore: 'Charger plus',
    },
    itemMenu: {
      active: 'Actif',
      willBeAvailable: "L'élément sera disponible le :",
      save: 'Enregistrer',
      copied: 'Copié',
      copyLink: 'Copier le lien',
      delete: 'Supprimer',
    },
    itemDesign: {
      linkColor: 'Couleur du lien',
      gradient: 'Dégradé',
      background: 'Arrière-plan',
      backgroundOpacity: "Opacité de l'arrière-plan",
      backgroundOpacityTooltip: "Faites glisser le curseur pour définir l'opacité de l'arrière-plan",
      backgroundDarkness: "Obscurcissement de l'arrière-plan",
      backgroundDarknessTooltip: "Faites glisser le curseur pour définir l'obscurcissement de l'arrière-plan",
      text: 'Texte',
      color1: 'Couleur 1',
      color2: 'Couleur 2',
      direction: 'Direction',
      directionTooltip: 'Faites glisser le curseur pour définir la direction du dégradé',
      offset: 'Décalage',
      offsetTooltip: 'Faites glisser le curseur pour définir le décalage du dégradé',
      linkHeight: 'Hauteur du lien',
      linkHeightTooltip: 'Faites glisser le curseur pour changer la hauteur du bouton',
      icon: 'Icône',
      iconTooltip: 'Choisissez une icône pour votre bouton',
      imageShape: "Forme de l'image",
      imageShapeTooltip: "Choisissez la forme de l'image pour votre lien",
    },
    menu: {
      linkInBio: 'Lien en bio',
      linkInBioApps: 'Lien en bio',
      posts: 'Publications',
      audience: 'Audience',
      orders: 'Commandes',
      marketing: 'Marketing',
      emailMarketing: 'Marketing par e-mail',
      socialPlanner: 'Planificateur social',
      shortLinks: 'Raccourcisseur de liens',
      businessCards: 'Cartes de visite',
      recentProfiles: 'Profils récents',
      standalonePage: 'Page autonome',
      soloApps: 'App en bio',
      bots: 'Bots',
      smartReply: 'Réponse automatique',
      analytics: 'Analytique',
      settings: 'Paramètres',
      shop: 'Gagner',
      publish: 'Publier',
      studio: 'Studio',
      blog: 'Blog',
      qrCodes: 'Codes QR',
      singlePages: 'Apps',
      forms: 'Formulaires',
      form: 'Formulaires',
      automations: 'Automatisations',
      community: 'Communauté',
      messages: 'Boîte de réception',
      agents: 'Agents',
      apps: 'Apps',
    },
    notificationsBlockSetting: {
      title: 'Notifications',
      setUp: 'Configurer',
      notifications: 'notifications',
      connect: 'Connecter',
      telegramText: "Recevoir une notification Telegram quand quelqu'un fait",
      change: 'modification',
      email: 'E-mail',
      emailText: "Recevoir un e-mail quand quelqu'un fait",
      webhook: 'Webhook',
      webhookTooltip: 'Ajouter un webhook',
      activate: 'Activer',
      webhookText: "Envoyer un événement vers un site web tiers quand quelqu'un fait",
      webhookURL: 'URL du webhook (requête POST)',
      error: 'Entrez un lien correct',
      save: 'Enregistrer',
    },
    navigation: {
      content: 'Contenu',
      pages: 'Pages',
      posts: 'Publications',
      shop: 'Boutique',
      blog: 'Blog',
      design: 'Design',
      analytics: 'Analytique',
      settings: 'Paramètres',
      apps: 'Applications',
      store: 'Boutique',
    },
    headerSettings: {
      design: 'Design',
      analytics: 'Analytique',
      settings: 'Paramètres',
      editTabs: 'Modifier les onglets',
    },
    unlockModal: {
      title: 'Débloquer les fonctionnalités Pro',
      text: 'Tirez le meilleur parti de votre lien en bio. Seulement 5$/mois — débloquez tout ce que Pro a à offrir :',
      checkBoxTitle1: 'Plus de blocs :',
      checkBoxText1: 'Ajoutez des formulaires, boutiques, comptes à rebours et lecteurs média',
      checkBoxTitle2: 'Analytique avancée :',
      checkBoxText2: 'Suivez les clics, vues et informations sur votre audience',
      checkBoxTitle3: 'Domaine personnalisé :',
      checkBoxText3: 'Utilisez votre propre domaine pour un aspect professionnel',
      checkBoxTitle4: 'Boutique intégrée :',
      checkBoxText4: 'Vendez des produits et gérez les commandes facilement',
      checkBoxTitle5: 'Outils SEO :',
      checkBoxText5: 'Améliorez votre classement avec les balises méta, UTM et slugs personnalisés',
      checkBoxTitle6: 'Intégrations :',
      checkBoxText6: "Synchronisez avec MailChimp, Zapier et d'autres outils",
      checkBoxTitle7: 'Marketing par e-mail :',
      checkBoxText7: 'Collectez des prospects et envoyez des campagnes automatisées',
      checkBoxTitle8: 'Support prioritaire :',
      checkBoxText8: "Obtenez de l'aide plus rapidement quand vous en avez besoin",
      upgradeToPro: 'Passer au Pro',
      viewAllPlans: 'Voir tous les forfaits',
    },
    profileSwitcher: {
      title: 'Tous les profils',
      button: 'Ajouter un nouveau profil',
    },
    account: {
      signOut: 'Se déconnecter',
      createNew: 'Créer un nouveau lien en bio',
      tryPro: 'Essayez Pro maintenant !',
      tryProText: 'Obtenez une personnalisation avancée et des informations plus approfondies sur votre audience pour attirer plus de visiteurs !',
    },
    accountSettings: {
      title: 'Paramètres du compte',
    },
    billingHistory: {
      title: 'Historique de facturation',
    },
    pages: {
      home: 'Accueil',
      newPage: 'Nouvelle page',
      managePages: 'Gérer les pages',
    },
    blockItem: {
      actionRequired: 'action requise',
    },
    blockContent: {
      untitled: 'Sans titre',
      clickToRename: 'Cliquez pour renommer le sous-titre',
      saving: 'enregistrement',
      saved: 'enregistré',
      deleteTitle: 'Êtes-vous sûr(e) de vouloir supprimer ce bloc ?',
      cancel: 'Annuler',
      yes: 'Oui',
    },
    addButtonModal: {
      title: "Ajouter un bouton d'action",
      close: 'Fermer',
      added: 'Ajouté',
      add: 'Ajouter',
      messageTitle: 'Message',
      messageText: 'Le bouton Message permet aux utilisateurs de vous contacter via une messagerie',
      subscribeTitle: "S'abonner",
      subscribeText: "Le bouton S'abonner permet aux utilisateurs de s'abonner à votre liste e-mail ou messagerie",
      ctaTitle: 'Bouton CTA',
      ctaText: "Le CTA est une invitation sur un site web qui indique à l'utilisateur d'effectuer une action spécifique",
      cartTitle: 'Panier',
      cartText: 'Affichez une icône de panier pour indiquer que les visiteurs peuvent faire des achats sur votre site web',
      contactTitle: 'Contact',
      contactText: "Permettez aux visiteurs d'accéder rapidement à vos coordonnées",
      qrcodeTitle: 'Code QR',
      qrcodeText: 'Affichez un code QR pour que les visiteurs puissent rapidement scanner et partager votre page',
      languageTitle: 'Langue',
      languageText: 'Permet aux visiteurs de changer la langue de votre page',
    },
    inputMask: {
      copyLink: 'Copier le lien',
    },
    videoLibrary: {
      addVideo: 'Ajouter une vidéo',
      myVideos: 'Mes vidéos',
      stockVideos: 'Vidéos stock',
      pasteUrl: "Coller l'URL",
      uploadVideo: 'Téléverser une vidéo',
    },
    createBlockModal: {
      searchTitle: 'Choisissez un bloc pour votre page',
      title: 'Ajouter à UniLink',
      contentTitle: 'Contenu',
      contentText: 'Créez et gérez votre page',
      growTitle: 'Prospects',
      growText: "Collectez des prospects et stimulez l'engagement",
      monetizeTitle: 'Monétiser',
      monetizeText: 'Vendez des produits, du contenu et des services',
      monetizationTitle: "Gagner et collecter de l'argent",
      monetizationText: 'Vendez des produits, services et collectez des pourboires',
      socialTitle: 'Contenu de réseaux sociaux',
      socialText: 'Partagez du contenu de réseaux sociaux sur votre UniLink',
      toolsTitle: 'Outils de croissance',
      toolsText: 'Développez, gérez et connectez-vous avec votre audience',
      search: 'Rechercher',
      all: 'Tous',
      allCategories: 'Toutes les catégories',
      content: 'Contenu',
      monetization: 'Monétisation',
      social: 'Social',
      tools: 'Outils',
      header: 'En-tête',
      headerText: 'Ajoutez une photo de profil et une biographie',
      link: 'Liens',
      linkText: 'Sélectionnez la disposition des liens',
      text: 'Texte',
      textText: 'Sélectionnez la disposition du texte',
      videos: 'Vidéos',
      videosText: 'Sélectionnez le type de vidéo',
      image: 'Image',
      imageText: "Ajoutez des blocs d'images",
      music: 'Musique',
      musicText: 'Sélectionnez le type de musique',
      socialFeeds: 'Flux sociaux',
      socialFeedsText: 'Sélectionnez le type de flux social',
      moreContent: 'Plus',
      moreContentText: 'Ajoutez plus de blocs de contenu',
      dataCollect: 'Collecte de données',
      dataCollectText: 'Sélectionnez le type de collecte de données',
      form: 'Formulaire',
      formText: 'Sélectionnez le type de formulaire',
      conversionTools: "Outils d'engagement",
      conversionToolsText: 'Ajoutez des blocs de conversion',
      products: 'Produits',
      productsText: 'Ajoutez des blocs de produits',
      donation: 'Pourboires et dons',
      tipsAndDonations: 'Pourboires et dons',
      tipsDonationsText: 'Blocs de pourboires et de dons',
      event: 'Événement',
      eventText: "Sélectionnez le type d'événement",
      quickAdd: 'Tous les blocs',
      quickAddText: "Ajouter n'importe quel bloc",
    },
    addBlockModal: {
      title: 'Ajouter à UniLink',
      dragToAdd: 'Glissez pour ajouter',
      contentTitle: 'Partager du contenu de base',
      contentText: 'Partagez du contenu directement sur votre UniLink',
      monetizationTitle: "Gagner et collecter de l'argent",
      monetizationText: 'Vendez des produits, services et collectez des pourboires',
      socialTitle: 'Contenu de réseaux sociaux',
      socialText: 'Partagez du contenu de réseaux sociaux sur votre UniLink',
      toolsTitle: 'Outils de croissance',
      toolsText: 'Développez, gérez et connectez-vous avec votre audience',
      search: 'Rechercher',
      searchPlaceholder: 'Rechercher du contenu...',
      all: 'Tous',
      allCategories: 'Toutes les catégories',
      content: 'Contenu',
      monetization: 'Monétisation',
      social: 'Social',
      tools: 'Outils',
    },
    tabNavigation: {
      tabView: 'Vue des onglets',
      tabViewTooltip: 'Sélectionnez la vue des onglets pour la navigation',
      colors: 'Couleurs',
      colorsTooltip: 'Choisissez les couleurs des publications et des boutons',
      tabs: 'Onglets',
      tabsTooltip: "Choisissez les onglets qui s'affichent dans la navigation du site web",
      content: 'Contenu',
      posts: 'Publications',
      store: 'Boutique',
      shop: 'Boutique',
      tabsSettings: 'Paramètres de navigation par onglets',
    },
    hideLogo: {
      text: 'Afficher le logo UniLink dans le pied de page de votre page.',
      text2: 'Afficher le logo UniLink dans le pied de page de votre page.',
    },
    palettePreview: {
      custom: "Couleur d'arrière-plan personnalisée",
      hexColor: 'Couleur hexadécimale',
      hexColorTooltip: 'Entrez la couleur hexadécimale de votre aperçu',
    },
    backgroundVideo: {
      insert: "Insérer l'URL",
      upload: 'Téléverser une vidéo',
      search: 'Rechercher une vidéo',
    },
    periodDropdown: {
      today: "Aujourd'hui",
      yesterday: 'Hier',
      last7days: '7 derniers jours',
      last30days: '30 derniers jours',
      allTime: 'Tout le temps',
      custom: 'Personnalisé',
    },
    subsections: {
      content: 'Contenu',
      design: 'Design',
      settings: 'Paramètres',
    },
    wrapperSettings: {
      lock: 'Passer au forfait PRO',
    },
    shareModal: {
      addSocials: 'Ajouter aux réseaux sociaux',
      shareTo: 'Partager sur',
      qrCode: 'Code QR',
      customizeUrl: "Personnaliser l'URL",
      goToMy: 'Aller à mon',
      print: 'Vous pouvez imprimer votre code QR unique sur',
      cards: 'des cartes de visite et des flyers',
      download: 'Télécharger',
      copy: 'Copier',
      previewMobile: 'Aperçu sur mobile',
      scanMobilePreview: 'Scannez le code QR sur votre appareil mobile pour prévisualiser votre site web',
      types: {
        socials: 'réseaux sociaux',
        shareTo: 'partager',
        qrCode: 'QR',
        title: 'Partagez votre UniLink',
        titleSocials: 'Ajoutez UniLink à vos réseaux sociaux',
        titleShareTo: 'Partager vers...',
        titleQRCode: 'Code QR',
        titlePreviewMobile: 'Aperçu sur mobile',
      },
      socialList: {
        instagramText: 'Ajoutez votre UniLink à votre profil Instagram. Copiez simplement votre URL UniLink, allez dans Modifier le profil, et collez-la dans le champ Site web.',
        facebookText:
          'Ajoutez votre UniLink à votre profil Facebook. Copiez simplement votre URL UniLink, allez à la page À propos de votre profil, cliquez sur Coordonnées et informations de base, puis cliquez sur + Ajouter un site web, collez votre URL UniLink dans le champ Adresse du site web, et cliquez sur Enregistrer.',
        tikTokText:
          'Ajoutez votre UniLink à votre profil Facebook. Copiez simplement votre URL UniLink, allez à la page À propos de votre profil, cliquez sur Coordonnées et informations de base, puis cliquez sur + Ajouter un site web, collez votre URL UniLink dans le champ Adresse du site web, et cliquez sur Enregistrer.',
        twitchText:
          "Ajoutez votre UniLink à votre chaîne Twitch. Copiez simplement votre URL UniLink, allez sur votre chaîne Twitch, cliquez sur À propos, puis cliquez sur Modifier à propos et les paramètres de liens, faites défiler jusqu'aux Liens sociaux, ajoutez UniLink dans le premier champ texte, et collez votre URL UniLink dans le second champ texte, puis cliquez sur Ajouter.",
        youTubeText:
          'Ajoutez votre UniLink à votre chaîne YouTube. Copiez simplement votre URL UniLink, allez sur votre chaîne YouTube, cliquez sur Personnaliser la chaîne, puis cliquez sur Informations de base, et sous Liens, ajoutez un titre de lien et collez votre URL UniLink dans le champ URL, puis cliquez sur Publier.',
        linkedInText:
          "Ajoutez votre UniLink à votre profil LinkedIn. Copiez simplement votre URL UniLink, allez sur votre profil LinkedIn, cliquez sur l'icône crayon, faites défiler jusqu'aux Coordonnées, collez votre URL UniLink dans le champ URL du site web, puis cliquez sur Appliquer.",
        pinterestText:
          'Ajoutez votre UniLink à votre profil Pinterest. Copiez simplement votre URL UniLink, allez dans vos paramètres Pinterest, collez votre URL UniLink dans le champ URL du site web, puis cliquez sur Enregistrer.',
        twitterText:
          'Ajoutez votre UniLink à votre profil Twitter. Copiez simplement votre URL UniLink, allez sur votre profil, cliquez sur Modifier le profil, et collez votre URL UniLink dans le champ Site web.',
      },
      share: {
        shareFacebook: 'Partager sur Facebook',
        shareLinkedIn: 'Partager sur LinkedIn',
        shareTwitter: 'Partager sur Twitter',
        shareWhatsApp: 'Partager via WhatsApp',
        shareMessenger: 'Partager via Messenger',
        shareEmail: 'Partager par e-mail',
      },
    },
  },
  popupMenu: {
    edit: 'Modifier la page',
    openInNewTab: 'Ouvrir dans un nouvel onglet',
    copyLink: "Copier l'URL",
    delete: 'Supprimer',
    showThumbnail: 'Afficher les miniatures des pages dans le tableau de bord',
    manageTabs: 'Gérer les onglets',
  },
  tabsDashboard: {
    labelAddNewTab: 'Nouvel onglet',
  },
  blocks: {
    header: {
      blockTitle: 'En-tête',
      blockText: 'Personnalisez votre photo de profil, ajoutez une courte biographie et mettez à jour vos icônes sociales',
      blockShortText: 'Personnalisez votre profil',
      layout: 'Disposition',
      layoutTooltip: "Créez la disposition de l'en-tête que vous souhaitez",
      layoutAlign: 'Alignement de la disposition',
      layoutAlignTooltip: 'Aligner le texte',
      profilePicture: 'Photo de profil',
      profilePictureTooltip: 'Changez votre photo de profil',
      pictureSize: "Taille de l'image",
      pictureSizeTooltip: "Vous pouvez changer la taille de l'image",
      pictureHeight: "Hauteur de l'image",
      pictureHeightCaption: "Vous pouvez changer la hauteur de l'image",
      preview: 'Aperçu',
      badge: 'Badge',
      badgeTooltip: "Ajoutez un badge vérifié à l'en-tête",
      tags: 'Tags',
      tagsTooltip: 'Afficher les tags de catégorie sous votre nom (jusqu’à 5)',
      tagsAdd: 'Ajouter des tags',
      addTags: '+ Ajouter des tags',
      tagsEdit: 'Modifier les tags',
      tagsCustomPlaceholder: 'Ajouter un tag personnalisé',
      tagsCustomAdd: 'Ajouter',
      tagsSuggested: 'Catégories suggérées',
      tagsSelected: 'Sélectionnés',
      tagsEmpty: 'Pas encore de tags — choisissez parmi les suggestions ou ajoutez les vôtres',
      tagsLimit: 'Max 5 tags',
      visibility: 'Visibilité',
      visibilityTooltip: 'Afficher ou masquer la photo de profil',
      cover: 'Couverture',
      coverTooltip: "Ajoutez une image ou une vidéo à la couverture de l'en-tête",
      addCover: 'Ajouter une couverture',
      image: 'Image',
      video: 'Vidéo',
      positionCover: 'Position du texte et du bouton',
      positionCoverTooltip: 'Faites glisser le curseur pour changer la position',
      buttons: 'Boutons',
      block: 'Bloc',
      videoProcessing: 'Traitement vidéo',
      vibe: 'Ambiance',
      vibeTooltip: 'Ajoutez votre ambiance',
      stories: 'Stories',
      storiesTooltip: 'Ajoutez vos stories',
      addStory: 'Ajouter une story',
      storiesSubtitle: 'Ajoutez une image ou une vidéo à vos stories',
      subscribeMethod: "Méthode d'abonnement",
      subscribeMethodTooltip: "Choisissez votre méthode d'abonnement",
      subscribeLink: "Lien d'abonnement",
      subscribeLinkTooltip: "Copiez votre lien d'abonnement",
      minWidth: 'Largeur minimale',
      addVCard: 'Ajouter une VCard',
      vCard: 'VCard',
      vCardTooltip: 'Vous pouvez ajouter des informations sur vous',
      buttonInline: "Bouton en ligne dans l'en-tête",
      buttonInsideContact: "Bouton à l'intérieur du bouton Contact",
      showSaveContact: 'Afficher enregistrer le contact',
      options: 'Options',
      showBusinessCard: 'Afficher la carte de visite',
      showBusinessCardCaption: 'Ajoute un bouton « Enregistrer le contact » ici.',
      editBusinessCard: 'Modifier la carte',
      needAddContact: 'Vous devez ajouter un bouton Contact',
      socialGap: 'Espacement',
      socialGapCaption: "Vous pouvez changer l'espacement",
      socialSize: 'Taille',
      socialSizeCaption: 'Vous pouvez changer la taille',
      icons: 'Icônes',
      iconsTooltip: 'Ajouter une icône au bouton',
    },
    text: {
      blockTitle: 'Texte',
      blockText: "Bloc de texte général pour écrire ce que vous voulez. Vous pouvez mettre en forme votre texte avec l'éditeur WYSIWYG",
      blockShortText: 'Bloc de texte général',
      title: 'Titre',
      titleText: 'Personnalisez la taille de votre titre',
      orderOfElements: 'Ordre des éléments',
      orderOfElementsTooltip: "Faites glisser le curseur pour changer l'ordre des éléments",
      changeOrder: "Changer l'ordre",
      text: 'Texte',
      content: 'Contenu',
      image: 'Image',
      button: 'Bouton',
      addButtons: "Ajouter d'autres boutons",
      displayedContent: 'Contenu affiché',
      displayedContentTooltip: 'Afficher ou masquer le contenu',
      buttonLayout: 'Disposition du bouton',
      buttonLayoutTooltip: 'Choisissez une disposition verticale ou horizontale des boutons',
    },
    timeline: {
      blockTitle: 'Chronologie',
      blockText: 'Affichez une chronologie verticale avec des événements. Chaque événement peut avoir une date/heure, un titre, une description et une image facultative',
      blockShortText: 'Afficher la chronologie des événements',
      editItem: "Modifier l'événement",
      title: 'Titre',
      titlePlaceholder: "Titre de l'événement",
      subtitle: 'Sous-titre',
      subtitlePlaceholder: 'Rôle ou affiliation (facultatif)',
      description: 'Description',
      descriptionPlaceholder: "Description de l'événement (facultatif)",
      startTime: 'Heure de début',
      endTime: 'Heure de fin',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      showEndDate: 'Afficher la date de fin',
      showEndDateTooltip: 'Désactivez pour les événements en cours (ex. « ici depuis 2023 »)',
      includeTime: "Inclure l'heure",
      includeTimeTooltip: "Si désactivé, seule la date sera affichée sans l'heure",
      image: 'Image',
      imagePlaceholder: 'Téléverser un avatar ou une icône',
      imageUploadFailed: "Impossible de téléverser l'image. Utilisez Mes médias ou collez un lien.",
      untitled: 'Sans titre',
      listLayout: 'Disposition en liste',
      lineColor: 'Couleur de la ligne',
    },
    trust: {
      blockTitle: 'Confiance',
      blockShortText: 'Partagez vos partenariats',
      blockText: 'Regroupez toutes vos connexions en un seul endroit.',
      titleText: 'Personnalisez la taille de votre titre',
      orderOfElements: 'Ordre des éléments',
      orderOfElementsTooltip: "Faites glisser le curseur pour changer l'ordre des éléments",
      changeOrder: "Changer l'ordre",
      text: 'Texte',
      content: 'Contenu',
      image: 'Image',
      button: 'Bouton',
      displayedContent: 'Contenu affiché',
      displayedContentTooltip: 'Afficher ou masquer le contenu',
      enterTrustLink: "Entrez l'URL du partenaire",
      enterTrustLinkTooltip: "Collez l'URL du partenaire",
      enterPartnerName: 'Entrez le nom du partenaire',
      enterPartnerUrl: 'https://www.votrePartenaire.com/',
      enterDescription: 'Entrez la description (optionnel)',
      partnerLogo: 'Logo du partenaire',
      uploadPartnerLogo: 'Téléversez le logo de votre partenaire',
    },
    link: {
      blockTitle: 'Liens',
      blockText: 'Dirigez le trafic vers votre site web, blog, boutique en ligne ou toute autre page web',
      blockShortText: 'Dirigez le trafic vers un site web',
      addLink: 'Ajouter un lien',
      addNewLink: 'Ajouter un nouveau lien',
      viewArchive: 'Voir les archives',
      archivedLinks: 'Liens archivés',
      noArchivedLinks: "Gardez votre administration de liens propre et concentrée en archivant les liens que vous n'utilisez pas actuellement.",
      archiveAllUnpublished: 'Archiver tous les liens non publiés',
      addFormExisting: 'Ajouter depuis les liens existants',
      addYourLink: 'Ajoutez votre lien au groupe',
      add: 'Ajouter',
      otherTypes: "Type d'action",
      link: 'Lien',
      navigate: 'Naviguer',
      navigateTo: 'Aller à',
      scrollBlock: 'Scroll to',
      copyText: 'Copy Text',
      navigatePage: 'Page',
      navigateProduct: 'Produit',
      navigateBlock: 'Bloc',
      modal: 'Modale',
      showModal: 'Afficher la modale',
      modalBlock: 'Afficher le bloc',
      modalItem: "Afficher l'élément",
      modalCustom: 'Personnalisé',
      document: 'Document',
      privat24: 'Privat24',
      phone: 'Appel téléphonique',
      viber: 'Ouvrir Viber',
      skype: 'Ouvrir Skype',
      email: 'Envoyer un e-mail',
      discount: 'Réduction',
      smartLink: 'Lien intelligent',
      mobileApp: 'Deep Link',
      enterURL: "Entrez l'URL",
      enterPrivat: 'Entrez votre carte de Privat24',
      enterPhone: 'Entrez le numéro de téléphone',
      enterViber: 'Entrez le numéro Viber',
      enterSkype: 'Entrez le Skype',
      enterEmail: "Entrez l'e-mail",
      enterTitle: 'Entrez le titre',
      enterCopyText: 'Entrez le texte à copier',
      enterPromoCode: 'Entrez le code promo',
      group: 'Créer un groupe',
      content: 'Contenu',
      links: 'Liens',
      heading: 'En-tête',
      settings: 'Paramètres',
      thumbnail: 'Miniature',
      typeTooltip: '  Le clic ouvrira ce lien',
      title: 'Titre',
      titleTooltip: 'Nom de votre lien',
      description: 'Description',
      descriptionTooltip: 'Description optionnelle des caractéristiques du lien, types, couleurs, tailles, etc.',
      label: 'Étiquette',
      labelTooltip: "Ajoutez un nom d'étiquette",
      button: 'Bouton',
      buttonTooltip: 'Ajoutez un nom de bouton',
      buttonText: 'Texte du bouton',
      buttonTextTooltip: 'Nom de votre bouton',
      buttonUrl: 'URL du bouton',
      buttonUrlTooltip: "Entrez l'URL du bouton",
      addLinkToGroup: 'Ajouter un lien au groupe',
      removeFromGroup: 'Retirer du groupe',
      deletePermanently: 'Supprimer définitivement',
      image: 'Image',
      buttonBg: 'Arrière-plan du bouton',
      postPreview: 'Aperçu de la publication',
      separatorType: 'Type de séparateur',
      separatorTypeTooltip: 'Ajoutez un type de séparateur à votre bouton',
      section: 'Section',
      sectionTooltip: 'Section du lien',
      descriptionSeparator: 'Description',
      descriptionSeparatorTooltip: 'Description optionnelle de la section',
      sectionText: 'Texte de la section',
      linkInstant: 'Redirection instantanée du lien',
      spotlight: 'Mettre le lien en avant',
      addEffect: 'Ajouter un effet spécial',
      countdown: 'Compte à rebours',
      countdownTimer: 'Minuteur',
      countdownText: "Ajoutez un compte à rebours en direct jusqu'au moment où votre lien devient cliquable",
      chooseDate: 'Choisir la date',
      chooseDateTooltip: 'Choisissez la date pour votre lien',
      chooseAction: "Choisir l'action",
      chooseActionTooltip: "Choisissez l'action pour votre lien",
      addCountdown: 'Ajouter un compte à rebours au lien',
      scheduler: 'Planificateur',
      schedule: 'Planifier',
      scheduleText: 'Choisissez une date et une heure futures pour activer votre lien',
      activateOn: 'Activer le',
      activateOnTooltip: 'Choisissez la date',
      deactivateOn: 'Désactiver le',
      deactivateOnTooltip: 'Choisissez la date',
      addSchedule: 'Ajouter une planification pour',
      scheduleError: 'La date de fin ne peut pas être antérieure à la date de début et la date de début ne peut pas être dans le passé.',
      scheduleErrorPast: "La date d'activation ne peut pas être dans le passé.",
      scheduleErrorPastDeactivate: 'La date de désactivation ne peut pas être dans le passé.',
      scheduleErrorOrder: "La date de désactivation doit être postérieure à la date d'activation.",
      activatesIn: "S'active dans",
      deactivatesIn: 'Se désactive dans',
      lock: 'Verrouiller',
      lockText: "Les visiteurs ne peuvent accéder à ce lien qu'en remplissant l'un des critères.",
      lockCode: 'Code',
      lockCodeTitle: 'Code pour déverrouiller ce lien',
      lockCodeText: 'Les visiteurs doivent entrer un code à 4 chiffres pour déverrouiller ce lien',
      lockSubscribe: "S'abonner",
      lockSubscribeTitle: "Les visiteurs doivent s'abonner à votre UniLink pour déverrouiller le lien.",
      lockSubscribeText: 'Le verrouillage a été configuré avec succès.',
      lockPayment: 'Paiement',
      lockPaymentText: 'Le verrouillage a été configuré avec succès.',
      price: 'Prix',
      priceTooltip: 'Ajoutez le prix de votre produit',
      lockAge: 'Date de naissance (Âge)',
      lockAgeTitle: "Définir l'âge minimum",
      lockAgeText: "Les visiteurs doivent avoir plus d'un certain âge pour déverrouiller le lien avec leur date de naissance",
      lockAgeAlert: 'Le verrouillage a été configuré avec succès.',
      lockSensitive: 'Contenu sensible',
      lockSensitiveText: "Les visiteurs doivent reconnaître que ce lien peut contenir du contenu qui n'est pas approprié pour tous les publics.",
      makeLink: 'Rendre le lien payant',
      addLock: 'Ajouter un verrouillage au lien',
      save: 'Enregistrer',
      clear: 'Effacer',
      buttonColor: 'Couleur du bouton',
      labelColor: "Couleur de l'étiquette",
      background: 'Arrière-plan',
      imageHeight: "Hauteur de l'image",
      imageHeightTooltip: "Faites glisser le curseur pour changer la hauteur de l'image",
      buttonMinimum: 'Hauteur minimale',
      buttonMinimumTooltip: 'Faites glisser le curseur pour changer la hauteur du bouton',
      textPosition: 'Position du texte',
      textPositionTooltip: 'Choisir la position verticale du texte',
      preview: 'aperçu',
      defaultDesign: 'Design par défaut',
      defaultDesignTooltip: 'Configurer le design par défaut des liens',
      defaultDesignTitle: 'Veuillez noter que ce design sera appliqué à tous les liens.',
      defaultDesignText: 'Vous pouvez changer le design par défaut des liens',
      changeDefault: 'Changer le défaut',
      applyDefault: 'Appliquer le défaut',
      scheduled: 'Planifié',
      scheduledVisible: 'Le lien planifié est maintenant visible',
      scheduledHidden: 'Le lien planifié est maintenant masqué',
      linkClickable: 'Lien cliquable dans',
      linkDisable: 'Lien désactivé dans',
      lockedBy: 'Verrouillé par',
      items: 'Éléments',
      doNotAnyLinks: "Vous n'avez pas encore de liens",
      sublinks: 'Sous-liens',
      layout: 'Disposition',
      layoutTooltip: 'Choisissez la disposition des sous-liens que vous souhaitez',
      hideGroupLink: 'Masquer le lien du groupe',
      rules: 'Règles',
      rulesText: 'Modifiez la visibilité de ce lien selon les visiteurs de votre page.',
      rulesEmpty: 'Aucune condition pour le moment. Ajoutez une condition pour contrôler qui voit ce lien.',
      rulesAddCondition: 'Ajouter une condition',
      rulesActive: 'Règles de visibilité',
      rulesIf: 'Si',
      rulesThen: 'Alors',
      ruleTypeLocation: 'Localisation',
      ruleTypeDevice: 'Appareil',
      ruleTypeTime: 'Jour et heure',
      ruleOperatorIs: 'est',
      ruleOperatorIsNot: "n'est pas",
      ruleActionHide: 'Masquer le lien',
      ruleActionShow: 'Afficher le lien',
      ruleSelectLocations: 'Sélectionner des localisations',
      ruleSearchLocations: 'Rechercher des pays…',
      ruleFrom: 'De',
      ruleTo: 'À',
      ruleAnyTime: 'Indifférent',
    },
    'data-collect': {
      blockTitle: 'Collecte de données',
      blockText: 'Collectez les e-mails ou numéros de téléphone de vos visiteurs',
      blockShortText: 'Collectez les e-mails',
      maxSize: 'Vous pouvez ajouter un maximum de 3 canaux',
      customTerms: 'CGU personnalisées',
      customTermsTooltip: 'Ajoutez des CGU personnalisées à votre formulaire',
      termsConditions: 'Conditions générales',
      text: 'Texte',
      subscribe: "S'abonner",
      title: 'Titre',
      titleTooltip: 'Entrez le titre des conditions générales',
      titleResultTooltip: 'Entrez le titre pour votre soumission',
      url: 'URL',
      urlTooltip: "Entrez l'URL",
      editItem: "Modifier l'élément",
      placeholder: 'Placeholder',
      placeholderTooltip: 'Entrez le texte du placeholder',
      button: 'Bouton',
      buttonTooltip: 'Texte qui motivera le visiteur à entrer son e-mail (réduction de 10%, abonnez-vous maintenant, téléchargez le fichier, etc.)',
      successMessage: 'Message de succès',
      successMessageTooltip: 'Message de succès pour vos abonnés',
      botURL: 'URL du bot (optionnel)',
      botURLTooltip: "Entrez l'URL de votre bot",
      botToken: 'Token du bot',
      botTokenTooltip: 'Entrez le token de votre bot',
      rewards: 'Réponses',
      rewardsTooltip: 'Ajoutez des réponses pour vos abonnés',
      addReward: 'Ajouter une réponse',
      thankYou: 'Message de remerciement',
      email: {
        none: 'Aucune',
        display: 'Afficher la réponse instantanément',
        send: 'Envoyer la réponse par e-mail',
        redirect: "Rediriger vers l'URL",
      },
      phone: {
        none: 'Aucune',
        display: 'Afficher la réponse instantanément',
        send: 'Envoyer la réponse par téléphone',
        redirect: "Rediriger vers l'URL",
      },
      telegram: {
        none: 'Aucune',
        display: 'Afficher la réponse instantanément',
        send: 'Envoyer la réponse via le bot Telegram',
        redirect: "Rediriger vers l'URL",
      },
      whatsapp: {
        none: 'Aucune',
        display: 'Afficher la réponse instantanément',
        send: 'Envoyer la réponse via le bot WhatsApp',
        redirect: "Rediriger vers l'URL",
      },
      instagram: {
        none: 'Aucune',
        display: 'Afficher la réponse instantanément',
        send: 'Envoyer la réponse via le bot Instagram',
        redirect: "Rediriger vers l'URL",
      },
      messenger: {
        none: 'Aucune',
        display: 'Afficher la réponse instantanément',
        send: 'Envoyer la réponse via le bot Messenger',
        redirect: "Rediriger vers l'URL",
      },
      viber: {
        none: 'Aucune',
        display: 'Afficher la réponse instantanément',
        send: 'Envoyer la réponse via le bot Viber',
        redirect: "Rediriger vers l'URL",
      },
      connect: 'Connecter',
      toChangeReward: 'Pour changer le type de réponse, vous devez supprimer la réponse actuelle',
      remove: 'Supprimer',
      viewTypes: 'Types de vue',
    },
    form: {
      blockTitle: 'Formulaire',
      blockText: 'Vous permet de capturer des informations et des données de votre audience',
      blockShortText: 'Capturer des informations',
      fields: 'Champs',
      fieldsTooltip: 'Ajoutez des champs au formulaire',
      addCustomField: 'Ajouter un champ personnalisé',
      addItem: 'Ajouter un élément',
      editItem: "Modifier l'élément",
      type: 'Type',
      typeTooltip: 'Choisissez le type de champ',
      string: 'Réponse courte',
      textarea: 'Réponse longue',
      dropdown: 'Menu déroulant',
      radio: 'Radio',
      checkbox: 'Case à cocher',
      date: 'Date',
      time: 'Heure',
      country: 'Pays',
      fieldName: 'Nom du champ',
      fieldNameTooltip: 'Entrez le nom du champ',
      name: 'Nom',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Entrez le texte du placeholder',
      required: 'Obligatoire',
      requiredTooltip: 'Vérifiez si le champ est obligatoire',
      value: 'Valeur',
      enterTitle: 'Entrez le titre',
      addValue: 'Ajouter une valeur',
      delete: 'Supprimer',
      update: 'Mettre à jour',
      add: 'Ajouter',
      confirmationPage: 'Action de confirmation',
      confirmationPageSubtitle: "Choisissez l'action résultat après la soumission du formulaire",
      successMessage: 'Message de succès',
      successMessageTooltip: 'Message de succès après la soumission du formulaire',
      thankYou: 'Message de remerciement',
      submit: 'Soumettre',
    },
    contact: {
      blockTitle: 'Contacts',
      blockText: 'Les contacts permettent aux utilisateurs de communiquer directement avec vous. Ajoutez votre téléphone, e-mail, messagerie ou localisation',
      blockShortText: 'Communiquer avec les utilisateurs',
      addNewContact: 'Ajouter un nouveau contact',
      newContact: 'Nouveau contact',
      friendlyName: 'Nom convivial',
    },
    faq: {
      blockTitle: 'FAQ',
      blockText: 'Foire aux questions — utilisée pour présenter une liste de réponses aux questions typiques que les utilisateurs pourraient poser',
      blockShortText: 'Questions fréquentes',
      addNewItem: 'Ajouter un nouvel élément',
      editItem: "Modifier l'élément",
      title: 'Titre',
      titleTooltip: 'Entrez le titre',
      description: 'Description',
      descriptionTooltip: 'Entrez la description',
      update: 'Mettre à jour',
      add: 'Ajouter',
      howToFind: 'Comment nous trouver',
    },
    ama: {
      blockTitle: 'Posez-moi une question',
    },
    feature: {
      blockTitle: 'Fonctionnalités',
      blockText: 'Section de texte avec image pour expliquer à vos utilisateurs pourquoi votre entreprise est la meilleure',
      blockShortText: 'Expliquez à vos utilisateurs pourquoi',
      title: 'Titre',
      titleTooltip: "Changer le titre de l'élément",
      description: 'Description',
      descriptionTooltip: "Changer la description de l'élément",
    },
    highlight: {
      blockTitle: 'Points forts',
      blockText: "Mettez en avant les liens les plus importants avec des miniatures (jusqu'à 3)",
      blockShortText: 'Mettez en avant les plus importants',
      title: 'Titre',
      titleTooltip: "Changer le titre de l'élément",
      url: 'URL',
      urlTooltip: "Changer l'URL de l'élément",
    },
    banner: {
      blockTitle: 'Bannière',
      blockText:
        'Image, vidéo ou votre dernier produit en vedette pour le faire ressortir. Vous pouvez ajouter un bouton CTA pour guider les utilisateurs vers votre objectif de conversion',
      blockShortText: 'Image, vidéo en vedette',
      height: 'Hauteur',
      heightTooltip: 'Changer la hauteur de la bannière',
    },
    slider: {
      blockTitle: 'Carrousel',
      blockText: "Carrousel d'images qui vous permet de présenter votre contenu visuel et d'ajouter différentes fonctionnalités",
      blockShortText: "Carrousel d'images",
      image: 'Image',
      imageTooltip: 'Image de votre galerie',
      addText: 'Ajouter du texte',
      title: 'Titre',
      titleTooltip: 'Titre de votre diapositive',
      titleSize: 'Taille du titre',
      titleSizeTooltip: 'Choisissez la taille pour une meilleure lisibilité',
      description: 'Description',
      descriptionTooltip: 'Description de votre diapositive',
      textColor: 'Couleur du texte',
      addButton: 'Ajouter un bouton',
      url: 'URL',
      urlTooltip: 'URL de votre image',
      button: 'Bouton',
      buttonTooltip: 'Titre de votre bouton',
      buttonText: 'Texte du bouton',
      buttonColor: 'Couleur du bouton',
      height: 'Hauteur',
      heightTooltip: 'Changer la hauteur des diapositives',
      view: 'Vue',
      viewTooltip: 'Choisissez la vue du carrousel',
      auto: 'Auto',
      square: 'Carré',
      rectangle: 'Rectangle',
      single: 'Simple',
      multi: 'Multiple',
    },
    gallery: {
      blockTitle: 'Galerie',
      blockText: "Carrousel d'images qui vous permet de présenter votre contenu visuel",
      blockShortText: "Carrousel d'images",
      image: 'Image',
      imageTooltip: 'Image de votre élément de galerie',
      layout: 'Disposition',
      layoutTooltip: 'Choisissez la disposition de la galerie',
      feed: 'Flux',
      slider: 'Carrousel',
    },
    blog: {
      blockTitle: 'Blog',
      blockText: 'Créez un blog de vos publications',
      blockShortText: 'Créer un blog',
      writeYourStory: 'Écrivez votre histoire',
      shortDescription: 'Description courte',
      shortDescriptionTooltip: 'Description optionnelle pour votre blog',
      description: 'Description',
    },
    map: {
      blockTitle: 'Carte',
      blockText: 'Ajoutez une carte Google pour aider les utilisateurs à trouver votre entreprise locale',
      blockShortText: 'Ajouter une carte Google',
      buttonText: 'Texte du bouton',
      buttonTextTooltip: 'Le bouton apparaît lorsque la deuxième vue est sélectionnée',
      text: 'Texte',
      addAddress: 'Ajouter une autre adresse',
      address: 'Adresse',
      addressTooltip: "Collez l'adresse depuis Google Maps par exemple",
      googleMap: "Google Maps (code d'intégration)",
      googleMapTooltip: "Collez le code d'intégration depuis Google Maps",
      howToFind: "Comment trouver le code d'intégration",
      incorrectCode: "Code d'intégration incorrect.",
      moreInfo: "Plus d'informations",
      code: 'Code',
      addressSettings: "Paramètres d'adresse",
      addressContent: "Ajoutez l'URL, le titre et le texte du bouton ou l'icône",
      title: 'Titre',
      titleTooltip: 'Le nom de votre adresse',
      url: 'URL',
      urlTooltip: "Collez l'URL de l'adresse depuis Google Maps par exemple",
      directionText: 'Texte de direction',
      directionTextTooltip: "Texte d'appel à l'action pour vos utilisateurs",
    },
    footer: {
      blockTitle: 'Pied de page',
      blockText: "Section de contenu en bas de page. Vous pouvez ajouter des coordonnées, des icônes de réseaux sociaux et un formulaire d'inscription par e-mail",
      blockShortText: 'Section de contenu en bas',
      addBlock: 'Ajouter un bloc',
      blockType: 'Type de bloc',
      blockTypeTooltip: 'Choisissez le type de bloc',
      addBlockTitle: 'Titre du bloc',
      addBlockTitleTooltip: 'Choisissez le titre du bloc',
      faq: 'FAQ',
      'data-collect': 'Collecte de données',
      contact: 'Contact',
      pages: 'Pages',
      payments: 'Paiements',
      social: 'Social',
      cancel: 'Annuler',
      add: 'Ajouter',
      None: 'Aucun',
      link: 'lien',
      faqText: 'Vous pouvez modifier les questions fréquemment posées dans le bloc FAQ. Vous pouvez y accéder en cliquant sur ce',
      socialText: 'Vous pouvez modifier les icônes sociales dans le bloc En-tête. Vous pouvez y accéder en cliquant sur ce',
      dataCollectText: 'Vous pouvez modifier la collecte de données dans le bloc Collecte de données. Vous pouvez y accéder en cliquant sur ce',
      contactText: 'Vous pouvez modifier le contact dans le bloc Contact. Vous pouvez y accéder en cliquant sur ce',
      pagesText: 'Vous pouvez ajouter de nouvelles pages sur le site web',
      paymentsText: 'Les méthodes de paiement seront affichées',
      showOnAllpages: 'Afficher sur toutes les pages',
      footerText: "Le pied de page de la page d'accueil est actuellement activé.",
      editSocialIcons: 'Vous pouvez modifier les icônes sociales dans la section En-tête. Vous pouvez y accéder en cliquant sur ce',
      editSubscribe: "Vous pouvez modifier l'abonnement dans la section Abonnement. Vous pouvez y accéder en cliquant sur ce",
      editContacts: 'Vous pouvez modifier les contacts dans la section Contacts. Vous pouvez y accéder en cliquant sur ce',
      editFrequently: 'Vous pouvez modifier les questions fréquemment posées dans la section FAQ. Vous pouvez y accéder en cliquant sur ce',
    },
    'chat-ai': {
      blockTitle: 'Chat IA',
      blockShortText: "Discuter avec l'IA",
      blockText: "Discuter avec l'IA",
      suggestionsTitle: 'Suggestions',
      suggestionsSubtitle: 'Invites rapides',
    },
    custom: {
      blockTitle: 'Personnalisé',
      blockShortText: "Micro-application propulsée par l'IA",
      blockText: "Décrivez une mini-application interactive et l'IA la générera pour vous",
    },
    shop: {
      blockTitle: 'Boutique',
      blockText: 'Ajoutez votre liste de produits',
      blockShortText: 'Ajoutez vos produits',
      view: 'Vue',
      products: 'Produits',
      categories: 'Catégories',
    },
    digital: {
      blockTitle: 'Produits numériques',
      blockText: 'Vendez un téléchargement numérique : PDF, tableurs, modèles, exclusivités',
      blockShortText: 'Vendre du numérique',
    },
    podcast: {
      blockTitle: 'Podcasts',
      blockText: 'Promouvez vos podcasts',
      blockShortText: 'Promouvez vos podcasts',
    },
    'page-list': {
      blockTitle: 'Liste de pages',
      blockText: 'Créez votre liste de pages',
      blockShortText: 'Créez votre liste de pages',
    },
    appointment: {
      blockTitle: 'Rendez-vous',
      blockText: 'Permettez aux visiteurs de réserver un créneau dans votre calendrier',
      blockShortText: 'Permettez aux visiteurs de réserver',
    },
    service: {
      blockTitle: 'Services',
      blockText: "Vous recevrez une notification par e-mail lorsqu'une demande vous sera soumise",
      blockShortText: 'Recevoir un e-mail',
    },
    requests: {
      blockTitle: 'Services',
      blockText: "Vous recevrez une notification par e-mail lorsqu'une demande vous sera soumise",
      blockShortText: 'Recevoir un e-mail',
    },
    tips: {
      blockTitle: 'Pourboires',
      blockText: 'UniLink rend le soutien amusant et facile. En quelques clics, vos fans peuvent effectuer le paiement et laisser un message',
      blockShortText: 'Rend le soutien amusant',
    },
    tip: {
      blockTitle: 'Pourboires',
      blockText: 'UniLink rend le soutien amusant et facile. En quelques clics, vos fans peuvent effectuer le paiement et laisser un message',
      blockShortText: 'Rend le soutien amusant',
    },
    donation: {
      blockTitle: 'Dons',
      blockText: 'UniLink rend le soutien amusant et facile. En quelques clics, vos fans peuvent effectuer le paiement et laisser un message',
      blockShortText: 'Rend le soutien amusant',
    },
    course: {
      blockTitle: 'Cours ou tutoriel',
      blockText: 'Permettez aux visiteurs de réserver un créneau dans votre calendrier',
      blockShortText: 'Permettez aux visiteurs de réserver',
    },
    event: {
      blockTitle: 'Événements ou billets',
      blockText: 'Permettez à votre audience de participer à vos événements',
      blockShortText: "Permettez à l'audience de participer",
    },
    menu: {
      blockTitle: 'Menu',
      blockText: 'Créez un menu unique avec des prix',
      blockShortText: 'Créer un menu unique',
    },
    booking: {
      blockTitle: 'Réservation',
      blockText: 'Permettez aux visiteurs de réserver vos espaces',
      blockShortText: 'Permettez aux visiteurs de réserver',
      name: 'Nom',
      nameCaption: "Entrez le nom de l'espace",
      description: 'Description',
      descriptionCaption: 'Courte description de cet espace',
      rentalType: 'Type de location',
      rentalTypeCaption: 'Par exemple : appartement, voiture, bureau',
      duration: 'Durée',
      durationCaption: 'Par exemple : par jour, par semaine, par mois',
      price: 'Prix',
      priceCaption: 'Prix de base pour cet espace',
      oldPrice: 'Ancien prix',
      oldPriceCaption: 'Ancien prix optionnel',
      rating: 'Note',
      ratingCaption: 'Note moyenne (optionnel)',
      label: 'Étiquette',
      labelCaption: 'Court badge comme HOT ou NOUVEAU',
      image: 'Image',
      imageCaption: 'Téléversez une image de couverture pour cet espace',
      location: 'Localisation',
      locationCaption: 'Ville, quartier ou adresse',
      capacity: 'Capacité (invités)',
      capacityCaption: "Nombre maximum d'invités",
      rooms: 'Chambres et surface',
      roomsCaption: 'Chambres, salles de bain et surface',
      bedrooms: 'Chambres',
      bathrooms: 'Salles de bain',
      areaSqM: 'Surface (m²)',
      minStay: 'Séjour minimum (jours)',
      minStayCaption: 'Nombre minimum de jours pour la réservation',
      requiresDeposit: 'Acompte requis',
      depositAmount: "Montant de l'acompte",
      depositAmountCaption: 'Acompte initial pour confirmer la réservation',
      noSmoking: 'Non-fumeur',
      noPets: "Pas d'animaux",
      amenitiesWifi: 'Wi-Fi',
      amenitiesParking: 'Parking',
      amenitiesKitchen: 'Cuisine',
      amenitiesHeating: 'Chauffage',
      amenitiesAC: 'Climatisation',
      amenitiesPool: 'Piscine',
      amenitiesSauna: 'Sauna',
      amenitiesRestrooms: 'Toilettes',
      validationNameRequired: 'Le nom est obligatoire',
      validationPriceRequired: 'Le prix doit être un nombre positif ou nul',
      validationDepositRequired: "Le montant de l'acompte est obligatoire lorsque l'acompte est activé",
      validationCapacityNumber: 'La capacité doit être un nombre positif ou nul',
      validationOldPriceNumber: "L'ancien prix doit être un nombre positif ou nul",
      brand: 'Marque',
      brandCaption: 'Marque de voiture, ex. Tesla',
      model: 'Modèle',
      modelCaption: 'Modèle de voiture, ex. Model 3',
      year: 'Année',
      yearCaption: 'Année de fabrication',
      color: 'Couleur',
      colorCaption: 'Couleur extérieure, ex. noir',
      fuelType: 'Type de carburant',
      fuelTypeCaption: 'Essence, diesel, électrique, hybride, etc.',
      transmission: 'Transmission',
      transmissionCaption: 'Automatique ou manuelle',
      seatCount: 'Nombre de sièges',
      seatCountCaption: 'Nombre de sièges dans la voiture',
      edit: "Modifier l'élément",
      add: 'Ajouter un élément',
    },
    membership: {
      blockTitle: 'Adhésion',
      blockText: 'Créez un abonnement gratuit ou payant à votre contenu',
      blockShortText: 'Créer un abonnement',
    },
    pricing: {
      blockTitle: 'Tarification',
      blockText: 'Créez un menu unique avec des prix',
      blockShortText: 'Créer un menu unique',
      name: 'Nom',
      nameTooltip: 'Entrez le nom de votre produit',
      pricingPlanName: 'Nom du plan tarifaire',
      pricingPlanNameTooltip: 'Entrez le nom de votre plan tarifaire',
      description: 'Description',
      descriptionTooltip: 'Entrez la description de votre produit',
      pricingPlanDescriptionTooltip: 'Entrez la description de votre plan tarifaire',
      priceValue: 'Valeur du prix',
      priceUnit: 'Unité de prix',
      label: 'Étiquette',
      labelTooltip: "Entrez l'étiquette de votre plan tarifaire",
      orderButtonText: 'Texte du bouton de commande',
      orderButtonTextDescriptionTooltip: 'Entrez le texte du bouton de commande de votre plan tarifaire',
      orderButtonLink: 'Lien du bouton de commande',
      orderButtonLinkDescriptionTooltip: 'Entrez le lien du bouton de commande de votre plan tarifaire',
      subtitle: 'Sous-titre',
      subtitleTooltip: 'Entrez le sous-titre de votre produit',
      price: 'Prix',
      priceTooltip: 'Entrez le prix de votre produit',
      pricingTiers: 'Niveaux de tarification',
      pricingTiersTooltip: 'Entrez les niveaux de tarification de votre produit',
      addPriceValue: 'Ajouter un autre prix',
      group: 'Groupe',
      groupTooltip: 'Choisissez le groupe de votre produit',
      image: 'Image',
      imageTooltip: 'Téléversez une image pour votre produit',
      unit: 'Unité de prix',
      unitTooltip: "Entrez l'unité de votre prix",
      addUnitTitle: 'Unités de prix',
      addPriceUnitValue: 'Ajouter une autre unité de prix',
      addUnitButtonText: 'Enregistrer',
      button: 'Bouton',
      buttonTooltip: 'Ajoutez un bouton pour votre produit',
      buttonAddText: '+ Ajouter un bouton',
      buttonModalTextField: 'Texte du bouton',
      buttonModalTextFieldTooltip: 'Entrez le texte du bouton',
      buttonModalURLField: 'URL du bouton',
      buttonModalURLFieldTooltip: "Entrez l'URL du bouton",
      buttonModalTitle: 'Ajouter un bouton',
      groups: {
        title: 'Groupes',
        subtitle: 'Ajouter, modifier et supprimer des groupes',
        groups: 'Groupes',
        groupsTooltip: 'Ajouter, modifier et supprimer des groupes',
        addNewGroup: 'Ajouter un nouveau groupe',
        newGroup: 'Nouveau groupe',
        titleGroup: 'Titre',
        titleGroupTooltip: 'Entrez le titre de votre groupe',
        descriptionGroup: 'Description',
        descriptionGroupTooltip: 'Entrez la description de votre groupe',
      },
    },
    menuBlock: {
      title: 'Menu',
      subtitle: 'Créez un menu avec des éléments et des prix',
      add: 'Ajouter un nouvel élément',
      edit: "Modifier l'élément",
      name: 'Nom',
      nameCaption: "Entrez le nom de l'élément",
      description: 'Description',
      descriptionCaption: 'Entrez une courte description',
      ingredients: 'Ingrédients',
      ingredientsCaption: 'Listez les ingrédients ou la composition',
      price: 'Prix',
      priceCaption: 'Entrez le prix',
      weight: 'Poids (g)',
      weightCaption: 'Entrez le poids en grammes',
      calories: 'Calories (kcal)',
      caloriesCaption: 'Entrez les calories en kcal',
      label: 'Étiquette',
      labelCaption: "Entrez le texte de l'étiquette",
      labelColor: "Couleur de l'étiquette",
      labelColorCaption: "Choisissez une couleur d'arrière-plan pour l'étiquette",
      image: 'Image',
      imageCaption: 'Téléversez une image pour votre élément',
      available: 'Disponible à la commande',
      visible: 'Visible sur la page',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: 'Affichez un NFT depuis la plateforme OpenSea',
      blockShortText: 'Afficher un NFT',
    },
    wallet: {
      wallet: 'Portefeuille',
      blockTitle: 'Portefeuille bancaire/crypto',
      blockText: 'Affichez votre carte bancaire ou portefeuille Bitcoin pour faciliter la copie et le transfert de fonds par vos utilisateurs',
      blockShortText: 'Affichez vos portefeuilles',
      title: 'Titre',
      titleTooltip: 'Titre de votre portefeuille',
      walletNumber: 'Numéro de portefeuille',
      walletNumberTooltip: 'Collez votre numéro de portefeuille',
      icon: 'Icône',
      iconTooltip: "Définissez l'icône pour votre portefeuille",
      card: 'Carte',
      bank: 'Banque',
      crypto: 'Crypto',
      transfer: 'Transfert',
      paymentLink: 'Lien de paiement',
      cardNumber: 'Numéro de carte',
      cardNumberTooltip: 'Collez votre numéro de carte',
      cardHolder: 'Titulaire de la carte',
      cardHolderTooltip: 'Entrez le titulaire de la carte',
      bankAccountDetails: 'Coordonnées bancaires',
      bankAccountDetailsTooltip: 'Entrez vos coordonnées bancaires',
      walletAddress: 'Adresse du portefeuille',
      walletAddressTooltip: "Entrez l'adresse de votre portefeuille",
      network: 'Réseau',
      networkTooltip: 'Entrez votre réseau',
      publicKey: 'Clé publique',
      publicKeyTooltip: 'Entrez votre clé publique',
      providerName: 'Nom du fournisseur',
      providerNameTooltip: 'Entrez le nom de votre fournisseur',
      link: 'Lien',
      linkTooltip: 'Entrez votre lien',
      serviceName: 'Nom du service',
      serviceNameTooltip: 'Entrez le nom de votre service',
      email: 'E-mail',
      emailTooltip: 'Entrez votre e-mail',
      phone: 'Téléphone',
      phoneTooltip: 'Entrez votre téléphone',
      username: "Nom d'utilisateur",
      usernameTooltip: "Entrez votre nom d'utilisateur",
      fullName: 'Nom complet',
      fullNameTooltip: 'Entrez votre nom complet',
      referenceNumber: 'Numéro de référence',
      referenceNumberTooltip: 'Entrez votre numéro de référence',
      country: 'Pays',
      countryTooltip: 'Entrez votre pays',
      transferProvider: 'Fournisseur de transfert',
      transferProviderTooltip: 'Entrez votre fournisseur de transfert',
      cryptoCurrency: 'Crypto-monnaie',
      cryptoCurrencyTooltip: 'Entrez votre crypto-monnaie',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: 'Présentez vos meilleurs médias et vidéos Instagram ou vendez vos produits avec un flux Instagram achetable',
      blockShortText: 'Vos meilleurs médias Instagram',
      blockConnectTitle: "Instagram n'est pas connecté",
      blockConnectText: 'Il semble que vos produits Instagram ne soient pas encore importés. Connectez votre compte maintenant',
      blockConnectButton: 'Ajouter Instagram',
      emptyList: "Vous n'avez pas encore de médias Instagram.",
      addInstagramUsername: "Ajouter le nom d'utilisateur Instagram",
      username: "Nom d'utilisateur",
      downloadTakes: "Le téléchargement prend jusqu'à 2 minutes",
      displayPost: 'Afficher la publication sur votre site web',
      view: 'Vue',
      redirect: 'Redirection URL',
      text: 'Texte et bouton',
      actionType: "Type d'action",
      url: 'URL',
      openInNewTab: 'Ouvrir dans un nouvel onglet',
      delete: 'Supprimer',
      cancel: 'Annuler',
      save: 'Enregistrer',
      editMedia: 'Modifier le média',
      title: 'Titre',
      automation: 'Automatisation',
      automationText: 'Automatisez votre compte avec les fonctionnalités Autopilote',
      autopilot: 'Autopilote',
      autopilotTooltip: 'Téléversez une publication avec la légende modèle et vos tags produits/liens seront automatiquement générés',
      switchTitle: 'Détecter automatiquement le titre, le prix, les liens',
      sampleCaption: 'Légende modèle : #49.99 #BelleRobe https://google.com',
      integrations: 'Intégrations',
      integrationsText: 'Ajoutez Instagram à votre site web',
      connectInstagram: 'Connecter Instagram',
      connectInstagramText: 'Connectez votre compte Instagram pour afficher vos publications ou reels au choix.',
      selectAccount: 'Sélectionner un compte',
      connectNewInstagram: 'Connecter un nouveau compte Instagram',
      continue: 'Continuer',
      disconnectInstagram: 'Déconnecter Instagram',
      addTag: 'Ajouter une étiquette',
      tagClickHint: "Cliquez sur l'image pour placer l'étiquette",
      tagPositionSet: 'Position défini. Remplissez les détails ci-dessous.',
      tagTypeLink: 'Lien',
      tagTypeProduct: 'Produit',
      tagLabel: 'Étiquette',
      tagSelectProduct: 'Sélectionner un produit',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: 'Présentez votre meilleure vidéo TikTok ou vendez vos produits avec un flux TikTok achetable',
      blockShortText: 'Votre meilleure vidéo TikTok',
      addTikTok: 'Ajouter un compte TikTok',
      individualVideo: 'Vidéo individuelle',
      videoCollection: 'Collection de vidéos',
      add: 'Ajouter',
      blockConnectTitle: "TikTok n'est pas connecté",
      blockConnectText: 'Il semble que vos produits TikTok ne soient pas encore importés. Connectez votre compte maintenant',
      blockConnectButton: 'Connecter TikTok',
      enterUsername: "Entrez le nom d'utilisateur",
      enterVideo: "Entrez l'URL d'une vidéo TikTok",
      emptyList: "Vous n'avez pas encore de médias TikTok.",
      editMedia: 'Modifier le média',
      addTikTokVideo: 'Ajouter une vidéo TikTok',
      displayPost: 'Afficher la publication sur votre site web',
      delete: 'Supprimer',
      cancel: 'Annuler',
      save: 'Enregistrer',
      integrations: 'Intégrations',
      integrationsText: 'Ajoutez TikTok à votre site web',
      connectTikTok: 'Connecter TikTok',
      disconnectTikTok: 'Déconnecter TikTok',
      individualText: "Vous ne pouvez pas connecter un compte TikTok à ce type de bloc ('individuel').",
      individualText2: 'Veuillez ajouter une vidéo TikTok unique à la place.',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: 'Présentez une vidéo YouTube ou un stream sur votre page. Taguez des produits sur la vidéo YouTube',
      blockShortText: 'Présentez une vidéo YouTube',
      enterYouTubeLink: "Entrez l'URL YouTube",
      enterYouTubeLinkTooltip: "Collez l'URL YouTube",
    },
    overview: {
      blockTitle: "Vue d'ensemble",
      blockText: 'Présentez une vidéo ou un stream sur votre page. Taguez des produits sur la vidéo',
      blockShortText: 'Taguer des produits sur la vidéo',
    },
    video: {
      blockTitle: 'Vidéo',
      blockText: 'Présentez une vidéo ou un stream sur votre page. Taguez des produits sur la vidéo',
      blockShortText: 'Présentez une vidéo',
    },
    twitter: {
      blockTitle: 'X (Twitter)',
      blockText: "Affichez vos Tweets sur votre page UniLink pour augmenter l'engagement",
      blockShortText: 'Affichez vos Tweets',
      twitterURL: 'URL Twitter',
      twitterURLTooltip: "Ajoutez l'URL depuis Twitter pour générer le code d'intégration",
      enterTwitterURL: 'Entrez une URL Twitter',
    },
    music: {
      blockTitle: 'Musique',
      blockText: 'Intégrez une chanson Spotify, SoundCloud, une playlist ou téléversez votre propre fichier audio',
      blockShortText: 'Ajoutez votre musique',
      brand: 'Marque',
      brandTooltip: 'Choisissez le type pour ajouter votre musique',
      url: 'URL',
      embed: "Code d'intégration",
      custom: 'Personnalisé',
      musicUrl: 'URL de la musique',
      musicUrlTooltip: "Entrez l'URL de la musique",
      embedCodeTitle: "Code d'intégration",
      embedCodeTooltip: "Collez le code d'intégration de votre chanson depuis la plateforme musicale choisie",
      audioFile: 'Fichier audio',
      uploadAudios: 'Vous ne pouvez téléverser que des fichiers audio ici',
      title: 'Titre',
      titleTooltip: 'Entrez le titre de votre musique',
      artist: 'Artiste',
      artistTooltip: "Entrez l'artiste de votre musique",
      audioFileTitle: 'Fichier audio',
      audioFileTooltip: 'Nom de votre fichier audio',
      coverImage: 'Image de couverture',
      coverImageTooltip: 'Téléversez une image pour votre musique',
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: 'Intégrez une vidéo ou un stream Twitch sur votre page',
      blockShortText: 'Intégrer une vidéo Twitch',
      twitchURL: 'URL Twitch',
      twitchURLTooltip: "Collez l'URL de la chaîne ou le nom de la chaîne",
      twitchTV: 'twitch.tv/...',
      displayTwitch: 'Afficher ma chaîne Twitch',
      displayChat: 'Afficher ma chaîne Twitch et le chat',
    },
    splash: {
      blockTitle: 'Écran de démarrage',
      blockText: 'Bannière plein écran avec texte et bouton qui apparaît avant le chargement du site pour promouvoir un produit ou événement',
      blockShortText: 'Bannière plein écran',
    },
    promo: {
      blockTitle: 'Barre promotionnelle',
      blockText: "Mise en avant qui vous permet d'afficher des promotions",
      blockShortText: 'Mettez en avant vos promotions',
    },
    welcome: {
      blockTitle: 'Message de bienvenue',
      blockText:
        "Rédigez des messages de bienvenue qui incitent les visiteurs à commencer une conversation. Il apparaît en bas de page pour accueillir les visiteurs et offrir de l'aide",
      blockShortText: 'Rédigez des messages de bienvenue',
    },
    review: {
      blockTitle: 'Avis',
      blockText: "Les avis aident les clients à en savoir plus sur le produit et à décider s'il leur convient",
      blockShortText: 'Les avis aident les clients',
      name: 'Nom',
      nameTooltip: "Entrez le nom de l'évaluateur",
      comment: 'Commentaire',
      commentTooltip: "Entrez le commentaire de l'évaluateur",
      date: 'Date',
      dateTooltip: "Entrez la date de l'évaluation",
      rate: 'Note',
      rateTooltip: "Définissez la note de l'avis",
      image: 'Image',
      imageTooltip: "Téléversez l'image de l'évaluateur",
    },
    coupon: {
      blockTitle: 'Coupons',
      blockText: 'Un coupon en ligne fait référence à un code de réduction ou un numéro qui peut être utilisé sur un site web',
      blockShortText: 'Coupon en ligne',
    },
    timer: {
      blockTitle: 'Minuteur',
      blockText:
        "Un minuteur est une horloge virtuelle sur une page qui compte à rebours à partir d'un certain nombre ou d'une date pour indiquer le début ou la fin d'un événement ou d'une offre",
      blockShortText: 'Un minuteur',
    },
    outfit: {
      blockTitle: 'Tenues',
      blockText: 'Créez votre propre liste de produits',
      blockShortText: 'Créer une liste de produits',
    },
    spacer: {
      blockTitle: 'Espacement',
      blockText: 'Ajoutez un espace vertical vide à votre page',
      blockShortText: 'Ajouter un espace vide',
    },
    html: {
      blockTitle: 'Code HTML',
      blockText:
        'Vous pouvez coller votre propre code HTML sur la page UniLink. HTML est un langage de balisage standard pour la création de pages web. Il prend en charge les iframes, sections, paragraphes et liens.',
      blockShortText: 'Collez votre propre HTML',
      markupCode: 'Code de balisage',
      markupCodeTooltip: 'Collez le code de balisage de votre HTML',
    },
    unlock: {
      blockTitle: 'Déverrouiller',
      blockText: 'Vous pouvez ajouter votre contenu à déverrouiller sur la page UniLink.',
      blockShortText: 'Collez votre fichier déverrouillable',
    },
    file: {
      blockTitle: 'Fichier',
      blockText:
        'Ce bloc vous permet de téléverser et de partager des fichiers tels que des documents, images ou audio. Les visiteurs peuvent facilement les consulter ou les télécharger directement depuis votre page.',
      blockShortText: 'Téléversez et partagez vos fichiers.',
      addNewItem: 'Ajouter un nouveau fichier',
      editFile: 'Modifier le fichier',
      fileName: 'Entrez le nom du fichier',
    },
    stat: {
      blockTitle: 'Statistiques',
      blockText:
        "Ce bloc vous permet d'afficher des informations clés sur votre page, comme les vues, les visiteurs ou l'engagement. Il vous aide à surveiller votre audience et à comprendre les performances de votre page.",
      blockShortText: 'Ajoutez des statistiques à votre page.',
      addNewItem: 'Ajouter une nouvelle statistique',
      editItem: 'Modifier la statistique',
      statName: 'Entrez le nom de la statistique',
      statValue: 'Entrez la valeur de la statistique',
      statDescription: 'Entrez la description de la statistique',
      statItemFields: 'Sélectionnez les champs à afficher.',
      feed: 'Flux',
      slider: 'Carrousel',
      titleSize: 'Taille du titre',
      subtitleTitleSize: 'Vous pouvez changer la taille du titre',
    },
    listing: {
      blockTitle: 'Annonce',
      blockText: "Affichez des annonces de biens ou d'articles avec images, détails et tarifs.",
      blockShortText: 'Ajoutez des annonces à votre page.',
    },
    rental: {
      blockTitle: 'Location',
      blockText: 'Listez des biens ou articles à louer avec disponibilité et tarifs par période.',
      blockShortText: 'Ajoutez des locations à votre page.',
    },
    'single-product': {
      blockTitle: 'Produit unique',
      blockText: "Mettez en avant un produit unique avec image, description et bouton d'achat.",
      blockShortText: 'Mettez un produit en avant.',
    },
    team: {
      blockTitle: 'Équipe',
      blockText: 'Présentez les membres de votre équipe avec photos, noms, rôles et liens sociaux.',
      blockShortText: 'Présentez votre équipe.',
    },
    timetable: {
      blockTitle: 'Emploi du temps',
      blockText: 'Affichez un planning hebdomadaire avec cours, événements ou sessions.',
      blockShortText: 'Ajoutez un planning hebdomadaire.',
    },
  },
};
